import { identity, isEqual, isObject } from 'lodash'

import { t } from 'plottr_locales'

import { batch } from './undo'

import {
  CHANGE_CURRENT_VIEW,
  CHANGE_ORIENTATION,
  FILE_LOADED,
  NAVIGATE_TO_BOOK_TIMELINE,
  FILE_SAVED,
  NEW_FILE,
  CHANGE_CURRENT_TIMELINE,
  CLEAR_TEMPLATE_FROM_TIMELINE,
  SET_CHARACTER_SORT,
  SET_PLACE_SORT,
  SET_CHARACTER_FILTER,
  EXPAND_TIMELINE,
  COLLAPSE_TIMELINE,
  SET_TIMELINE_FILTER,
  SET_PLACE_FILTER,
  RESET_TIMELINE,
  RECORD_TIMELINE_SCROLL_POSITION,
  EDIT_FILENAME,
  SET_TIMELINE_SIZE,
  OPEN_ATTRIBUTES_DIALOG,
  CLOSE_ATTRIBUTES_DIALOG,
  SET_NOTE_SORT,
  SET_NOTE_FILTER,
  SET_OUTLINE_FILTER,
  LOAD_UI,
  LOAD_FILE,
  SET_NOTES_SEARCH_TERM,
  SET_CHARACTERS_SEARCH_TERM,
  SET_PLACES_SEARCH_TERM,
  SET_TAGS_SEARCH_TERM,
  SET_OUTLINE_SEARCH_TERM,
  SET_TIMELINE_SEARCH_TERM,
  SET_ACTIVE_TIMELINE_TAB,
  SET_TIMELINE_VIEW,
  SELECT_CHARACTER_ATTRIBUTE_BOOK_TAB,
  SELECT_CHARACTER,
  SET_CHARACTER_VIEW,
  SET_CARD_DIALOG_OPEN,
  SET_CARD_DIALOG_CLOSE,
  OPEN_NEW_BOOK_DIALOG,
  OPEN_EDIT_BOOK_DIALOG,
  CLOSE_BOOK_DIALOG,
  RECORD_OUTLINE_SCROLL_POSITION,
  RECORD_OUTLINE_PLAN_SCROLL_POSITION,
  CLOSE_SEARCH,
  OPEN_SEARCH,
  SET_SEARCH_TERM,
  SELECT_OUTLINE_CARD,
  SELECT_NOTE,
  SELECT_PLACE,
  SELECT_TAG,
  NEXT_SEARCH_HIT,
  PREVIOUS_SEARCH_HIT,
  START_DELETING_CARD_FROM_CARD_DIALOG,
  STOP_DELETING_CARD_FROM_CARD_DIALOG,
  SHOW_CARD_DIALOG_COLOR_PICKER,
  HIDE_CARD_DIALOG_COLOR_PICKER,
  START_REMOVING_TEMPLATE_FROM_CARD_DIALOG,
  STOP_REMOVING_TEMPLATE_FROM_CARD_DIALOG,
  SET_ACTIVE_TAB_ON_CARD_DIALOG,
  SHOW_CARD_DIALOG_TEMPLATE_PICKER,
  HIDE_CARD_DIALOG_TEMPLATE_PICKER,
  FINISH_EDITING_SELECTED_PLACE,
  HIDE_PLACE_ATTRIBUTE_DIALOG,
  HIDE_PLACE_CATETORIES_MODAL,
  HIDE_PLACE_FILTER_LIST,
  HIDE_PLACE_SORT,
  SHOW_PLACE_ATTRIBUTE_DIALOG,
  SHOW_PLACE_CATETORIES_MODAL,
  SHOW_PLACE_FILTER_LIST,
  SHOW_PLACE_SORT,
  START_EDITING_SELECTED_PLACE,
  START_EDITING_SELECTED_NOTE,
  FINISH_EDITING_SELECTED_NOTE,
  SHOW_NOTES_CATEGORY_DIALOG,
  HIDE_NOTES_CATEGORY_DIALOG,
  SHOW_NOTES_ATTRIBUTES_DIALOG,
  HIDE_NOTES_ATTRIBUTES_DIALOG,
  SHOW_NOTES_FILTER_LIST,
  HIDE_NOTES_FILTER_LIST,
  SHOW_NOTES_SORT,
  HIDE_NOTES_SORT,
  SHOW_CHARACTERS_ATTRIBUTES_DIALOG,
  HIDE_CHARACTERS_ATTRIBUTES_DIALOG,
  SHOW_CHARACTERS_CATEGORIES_DIALOG,
  HIDE_CHARACTERS_CATEGORIES_DIALOG,
  START_EDITING_SELECTED_CHARACTER,
  FINISH_EDITING_SELECTED_CHARACTER,
  SHOW_CHARACTERS_TEMPLATE_PICKER,
  HIDE_CHARACTERS_TEMPLATE_PICKER,
  START_CREATING_CHARACTER,
  FINISH_CREATING_CHARACTER,
  SET_CHARACTER_TEMPLATE_DATA,
  SHOW_CHARACTER_FILTER,
  HIDE_CHARACTER_FILTER,
  SHOW_CHARACTER_SORT,
  HIDE_CHARACTER_SORT,
  SHOW_CHARACTER_DETAILS,
  HIDE_CHARACTER_DETAILS,
  START_DELETING_CHARACTER,
  FINISH_DELETING_CHARACTER,
  START_REMOVING_TEMPLATE_FROM_CHARACTER,
  FINISH_REMOVING_TEMPLATE_FROM_CHARACTER,
  SET_TEMPLATE_TO_REMOVE_FROM_CHARACTER,
  SET_ACTIVE_CHARACTER_TAB,
  SHOW_CHARACTER_EDITOR_TEMPLATE_PICKER,
  HIDE_CHARACTER_EDITOR_TEMPLATE_PICKER,
  START_EDITING_OUTLINE_CARD,
  FINISH_EDITING_OUTLINE_CARD,
  TOGGLE_ADVANCED_SAVE_TEMPLATE_PANEL,
  SET_FOCUSSED_TIMELINE_TAB_BEAT,
  SET_TIMELINE_TAB_BEAT_TO_DELETE,
  SET_ACT_CONFIG_MODAL_OPEN,
  SET_EDITING_BEAT_ID,
  OPEN_RESTRUCTURE_TIMELINE_MODAL,
  CLOSE_RESTRUCTURE_TIMELINE_MODAL,
  PUSH_FOCUS,
  EDIT_SELECTED_TAG,
  FINISH_EDITING_SELECTED_TAG,
  TOGGLE_REPLACE_SEARCH,
  SET_REPLACEMENT_TEXT,
  OPEN_REPLACE,
  TOGGLE_HIT_MARKED_FOR_REPLACEMENT,
  REPLACE_MARKED_HITS,
  UPDATE_HITS_MARKED_FOR_REPLACEMENT,
  START_SCANNING_SEARCH,
  START_EDITING_BEAT_HEADING_TITLE,
  STOP_EDITING_BEAT_HEADING_TITLE,
  START_EDITING_PLOTLINE_HEADING_TITLE,
  STOP_EDITING_PLOTLINE_HEADING_TITLE,
  START_JUMPING,
  FINISH_JUMPING,
  START_VIEWING,
  START_SEARCHING,
  SET_REPLACE_WORD,
  SET_DASHBOARD_MODAL_VIEW,
  TOGGLE_ID_MARKED_TO_IMPORT,
  TOGGLE_ALL_SECTION_MARKED_TO_IMPORT,
  TOGGLE_BOOK_TO_IMPORT,
  CLOSE_IMPORT_PLOTTR_MODAL,
  SHOW_IMPORT_DATA_PICKER,
  TOGGLE_CUSTOM_ATTRIBUTE_TO_IMPORT,
  SHOW_PRO_ACCOUNT_RECENT_FILES,
  CLOSE_CONFLICT_RESOLUTION_MODAL,
  SET_OUTLINE_VIEW,
  SHOW_FULLTEXT_CHAPTER_TITLE,
  SET_FULLTEXT_PLOTLINE_COLOR,
  SHOW_FULLTEXT_PAGE_LAYOUT_CONFIG,
  SHOW_FULLTEXT_BEAT_TITLE,
  HIDE_FULLTEXT_PAGE_LAYOUT_CONFIG,
  TOGGLE_FULLTEXT_SHOW_BEAT_GAPS,
  SET_FULLTEXT_CARD_TITLE_ALIGNMENT,
  SET_OUTLINE_DETAILS_PINNED,
  SET_FULLTEXT_BEAT_TITLE_ALIGNMENT,
  SHOW_FULLTEXT_CARD_HOVER_DETAILS,
  HIDE_FULLTEXT_CARD_HOVER_DETAILS,
  ADD_OUTLINE_FULLTEXT_ZOOM,
  REDUCE_OUTLINE_FULLTEXT_ZOOM,
  TOGGLE_OUTLINE_CARD_COLOR_SOURCE,
  TOGGLE_SMALL_TIMELINE_CARD_COLOR_SOURCE,
  SELECT_CHARACTER_FOR_CHANGING_IMAGE,
  DESELECT_CHARACTER_FOR_CHANGING_IMAGE,
  OPEN_RELATIONSHIP_EDITOR,
  CLOSE_RELATIONSHIP_EDITOR,
  SELECT_RELATIONSHIP_TYPE,
  SHOW_RELATIONSHIP_EDITOR_COLOUR_PICKER,
  HIDE_RELATIONSHIP_EDITOR_COLOUR_PICKER,
  START_EDITING_FAMILY_TREE_NAME_BY_ID,
  SELECT_FAMILY_TREE,
  FINISH_EDITING_FAMILY_TREE_NAME,
  SET_FAMILY_TREE_SCALE,
  SET_IDEA_SEARCH_TERM,
  SET_FAMILY_TREE_POSITION,
  OPEN_DOCUMENTATION_MODAL,
  CLOSE_DOCUMENTATION_MODAL,
  SHOW_PREVIEW_PANELS,
  HIDE_PREVIEW_PANELS,
  TOGGLE_EXPAND_PREVIEW_PANEL,
  TOGGLE_MINIMIZE_PREVIEW_PANEL,
  SAVE_PINNED_PREVIEW_COORDS,
  CLOSE_QUICK_EDIT_MODAL,
  SHOW_QUICK_EDIT_MODAL,
  UNPIN_ALL_PREVIEW_PANELS,
  SHOW_PREVIEW_PANELS_CONFIRM_MODAL,
  SET_PANEL_SHRINKED,
  CLOSE_IDEA_BOARD_PREVIEW_MODAL,
  SAVE_NEW_IDEA,
  DELETE_IDEA_FROM_BOARD,
  EDIT_IDEA,
  TOGGLE_SHOW_IDEA_SEARCH_BAR,
  OPEN_IDEA_CONFIRM_MODAL,
  CLOSE_IDEA_CONFIRM_MODAL,
  ADD_CHARACTER_FROM_IDEA_BOARD,
  ADD_PLACE_FROM_IDEA_BOARD,
  ADD_NOTE_FROM_IDEA_BOARD,
  TOGGLE_SHOW_COLLAPSIBLE_IDEA_CARD_DESCRIPTION,
  SHOW_IDEA_BOARD_PREVIEW_MODAL,
  HIDE_IDEA_BOARD,
  SHOW_IDEA_BOARD,
  PIN_NOTE_TO_PINBOARD,
  UNPIN_NOTE_FROM_PINBOARD,
  UNPIN_CHARACTER_FROM_PIN_BOARD,
  PIN_CHARACTER_TO_PIN_BOARD,
  PIN_PLACE_TO_PIN_BOARD,
  UNPIN_PLACE_FROM_PIN_BOARD,
  PIN_CARD_TO_PIN_BOARD,
  UNPIN_CARD_FROM_PIN_BOARD,
  FLOAT_PREVIEW_PANEL,
  ADD_CHARACTER_TO_BOOKMARKS,
  REMOVE_CHARACTER_FROM_BOOKMARKS,
  ADD_NOTE_TO_BOOKMARKS,
  REMOVE_NOTE_FROM_BOOKMARKS,
  ADD_PLACE_TO_BOOKMARKS,
  REMOVE_PLACE_FROM_BOOKMARKS,
  ADD_CARD_TO_BOOKMARKS,
  REMOVE_CARD_FROM_BOOKMARKS,
  SET_SEARCH_MODAL_ACTIVE_TAB,
  OPEN_SEARCH_MODAL_TO_BOOKMARKS,
  TOGGLE_COLLAPSE_BOOKMARK_KIND,
  SET_BOOKMARKS_SEARCH_TERM,
  OPEN_TEMP_CARD_MODAL,
  TOGGLE_SHOW_PANELS_WITH_IDEABOARD,
  COLLAPSE_CHARACTER_CATEGORIES,
  EXPAND_CHARACTER_CATEGORIES,
  TOGGLE_CHARACTERS_TAB_LIST_VIEW,
  SET_THEME,
  EXPAND_PLACE_CATEGORIES,
  COLLAPSE_PLACE_CATEGORIES,
  TOGGLE_PLACES_TAB_LIST_VIEW,
  EXPAND_NOTE_CATEGORIES,
  COLLAPSE_NOTE_CATEGORIES,
  TOGGLE_NOTES_TAB_LIST_VIEW,
  SHOW_MOBILE_CONTROLS_MODAL,
  HIDE_MOBILE_CONTROLS_MODAL,
  SET_CHARACTER_CATEGORY_FILTER,
  SET_PLACE_CATEGORY_FILTER,
  SET_NOTE_CATEGORY_FILTER,
  SHOW_TIMELINE_FILTER_LIST,
  HIDE_TIMELINE_FILTER_LIST,
} from '../constants/ActionTypes'
import selectors from '../selectors'
import { cardFocusPath, outlineCardFocusPath } from '../helpers/cards'
import { projectFocusPath } from '../helpers/project'
import { incrementJumpCounter } from './applicationState'
import { noteFocusPath } from '../helpers/notes'
import { characterFocusPath } from '../helpers/characters'
import { placeFocusPath } from '../helpers/places'
import { tagFocusPath } from '../helpers/tags'
import { lineFocusPath } from '../helpers/lines'
import { beatFocusPath } from '../helpers/beats'
import { parseNumberOrString } from '../helpers/parseNumberOrString'
import { safeParseInt } from '../helpers/safeParseInt'
import { unescapeUIPathElement } from '../helpers/ui'

/**
 * @typedef {import('../types/plottr').PreviewPanelEntityKind} PreviewPanelEntityKind
 * @typedef {import('../types/plottr').ImportModalUiData} ImportModalUiData
 * @typedef {import('../types/plottr').PlottrFileFile} PlottrFileFile
 * @typedef {import('../types/plottr').ActView} ActView
 * @typedef {import('../types/plottr').CharacterView} CharacterView
 * @typedef {import('../types/plottr').DashboardModalView} DashboardModalView
 * @typedef {import('../types/plottr').OutlineTabView} OutlineTabView
 * @typedef {import('../types/plottr').TextAlignment} TextAlignment
 * @typedef {import('../types/plottr').CardColorSource} CardColorSource
 * @typedef {import('../types/plottr').SearchDialogActiveTab} SearchDialogActiveTab
 * @typedef {import('../types/plottr').DocumentationType} DocumentationType
 * @typedef {import('../types/plottr').LegacyCustomAttribute} LegacyCustomAttribute
 * @typedef {import('../types/plottr').IdeaBoardEntityKind} IdeaBoardEntityKind
 * @typedef {import('../types/plottr').BookmarkEntityKind} BookmarkEntityKind
 * @typedef {import('../types/plottr').PlottrFileUi} PlottrFileUI
 * @typedef {import('../types/plottr').TextAttributeData} TextAttributeData
 * @typedef {import('../types/plottr').SearchHit} SearchHit
 * @typedef {import('../types/plottr').HierarchyLevelsPlottrFile} HierarchyLevelsPlottrFile
 * @typedef {import('../types/plottr').LegacyCustomAttributes} LegacyCustomAttributes
 * @typedef {import('../types/plottr').IdeaItem} IdeaItem
 * @typedef {import('../types/plottr').FilePermission} FilePermission
 * @typedef {import('../types/system').CharacterTemplate} CharacterTemplate
 * @typedef {import('../types/system').CharacterCustomTemplate} CharacterCustomTemplate
 * @typedef {import('../types/system').SystemState} SystemState
 * @typedef {import('../types/plottr-in-your-pocket').UniversalIdeaId} UniversalIdeaId
 * @typedef {import('../index').Dispatch} Dispatch
 * @typedef {import('../index').GetState} GetState
 * @typedef {import('../index').Beat} Beat
 * @typedef {import('../index').Card} Card
 * @typedef {import('../index').Line} Line
 * @typedef {import('../index').Note} Note
 * @typedef {import('../index').Tag} Tag
 * @typedef {import('../index').Character} Character
 * @typedef {import('../index').Place} Place
 * @typedef {import('../index').Slate} Slate
 * @typedef {import('../index').EntityKind} EntityKind
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').PltrAction} PltrAction
 * @typedef {import('../index').PlottrTab} PlottrTab
 * @typedef {import('../index').TimelineOrientation} TimelineOrientation
 * @typedef {import('../index').PlottrFile} PlottrFile
 * @typedef {import('../index').TimelineSize} TimelineSize
 * @typedef {import('../index').Books} Books
 * @typedef {import('../index').PlottrFileBeats} PlottrFileBeats
 * @typedef {import('../index').PlottrFileImages} PlottrFileImages
 * @typedef {import('../index').DOMSelection} DOMSelection
 * @typedef {import('../index').SlateSelection} SlateSelection
 */

/**
 * @typedef {{ type: 'ADD_CHARACTER_FROM_IDEA_BOARD', name: String, description: String | Slate, picture: String | null, audioClip: number | Null, customAttributes: Array<LegacyCustomAttribute>, currentBookId: number | 'all', nextCharacterId: number }} AddCharacterFromIdeaBoardAction
 * @typedef {{ type: 'RESET_TIMELINE', bookId: number | 'series', beatIds: Record<number, boolean>, lineIds: Record<number, boolean>, isSeries: boolean }} ResetTimelineAction
 * @typedef {{ type: 'CLEAR_TEMPLATE_FROM_TIMELINE', bookId: number | 'series', templateId: String, beatIds: Array<number>, lineIds: Array<number> }} ClearTemplateFromTimeline
 * @typedef {{ type: 'CHANGE_CURRENT_TIMELINE', id: number | 'series', currentTimeline: 'series' | number, timelineView: ActView }} ChangeCurrentTimelineAction
 */

/**
 * @typedef {ReturnType<typeof _openIdeaConfirmModal> | ReturnType<typeof changeCurrentView> | ReturnType<typeof changeOrientation> | ReturnType<typeof loadFile> | ReturnType<typeof newFile> | ReturnType<typeof fileSaved> | ReturnType<typeof setCharacterSort> | ReturnType<typeof setPlaceSort> | ReturnType<typeof setNoteSort> | ReturnType<typeof setCharacterFilter> | ReturnType<typeof setPlaceFilter> | ReturnType<typeof setNoteFilter> | ReturnType<typeof setTimelineFilter> | ReturnType<typeof setOutlineFilter> | ReturnType<typeof navigateToBookTimeline> | ReturnType<typeof expandTimeline> | ReturnType<typeof collapseTimeline> | ReturnType<typeof recordTimelineScrollPosition> | ReturnType<typeof recordOutlineScrollPosition> | ReturnType<typeof recordOutlinePlanScrollPosition> | ReturnType<typeof _editFilename> | ReturnType<typeof setTimelineSize> | ReturnType<typeof openAttributesDialog> | ReturnType<typeof closeAttributesDialog> | ReturnType<typeof setNotesSearchTerm> | ReturnType<typeof setCharactersSearchTerm> | ReturnType<typeof setPlacesSearchTerm> | ReturnType<typeof setTagsSearchTerm> | ReturnType<typeof setOutlineSearchTerm> | ReturnType<typeof setTimelineSearchTerm> | ReturnType<typeof setIdeaSearchterm> | ReturnType<typeof patchFile> | ReturnType<typeof setTimelineActiveTab> | ReturnType<typeof setTimelineView> | ReturnType<typeof selectCharacterAttributeBookTab> | ReturnType<typeof selectCharacter> | ReturnType<typeof setCharacterView> | ReturnType<typeof setCardDialogClose> | ReturnType<typeof openNewBookDialog> | ReturnType<typeof openEditBookDialog> | ReturnType<typeof closeBookDialog> | ReturnType<typeof closeSearch> | ReturnType<typeof toggleAdvancedSaveTemplatePanel> | ReturnType<typeof openSearch> | ReturnType<typeof openReplace> | ReturnType<typeof setFocussedTimelineTabBeat> | ReturnType<typeof setBookmarksSearchTerm> | ReturnType<typeof _updateHitsMarkedForReplacement> | ReturnType<typeof _setSearchTerm> | ReturnType<typeof setTimelineTabBeatToDelete> | ReturnType<typeof selectOutlineCard> | ReturnType<typeof setActConfigIsOpen> | ReturnType<typeof selectNote> | ReturnType<typeof selectPlace> | ReturnType<typeof selectTag> | ReturnType<typeof startJumping> | ReturnType<typeof finishJumping> | ReturnType<typeof _pushFocus> | ReturnType<typeof _nextSearchHit> | ReturnType<typeof _previousSearchHit> | ReturnType<typeof startDeletingCardFromCardDialog> | ReturnType<typeof stopDeletingCardFromCardDialog> | ReturnType<typeof showCardDialogColorPicker> | ReturnType<typeof hideCardDialogColorPicker> | ReturnType<typeof showCardDialogTemplatePicker> | ReturnType<typeof hideCardDialogTemplatePicker> | ReturnType<typeof startRemovingTemplateFromCardDialog> | ReturnType<typeof stopRemovingTemplateFromCardDialog> | ReturnType<typeof setActiveTabOnCardDialog> | ReturnType<typeof showPlaceAttributeDialog> | ReturnType<typeof hidePlaceAttributeDialog> | ReturnType<typeof startEditingSelectedPlace> | ReturnType<typeof finishEditingSelectedPlace> | ReturnType<typeof showPlaceCategoryModal> | ReturnType<typeof hidePlaceCategoryModal> | ReturnType<typeof showPlaceFilterList> | ReturnType<typeof hidePlaceFilterList> | ReturnType<typeof showPlaceSort> | ReturnType<typeof hidePlaceSort> | ReturnType<typeof startEditingSelectedNote> | ReturnType<typeof finishEditingSelectedNote> | ReturnType<typeof showNotesCategoryDialog> | ReturnType<typeof hideNotesCategoryDialog> | ReturnType<typeof showNotesAttributesDialog> | ReturnType<typeof hideNotesAttributesDialog> | ReturnType<typeof showNotesFilterList> | ReturnType<typeof hideNotesFilterList> | ReturnType<typeof showNotesSort> | ReturnType<typeof hideNotesSort> | ReturnType<typeof showCharactersAttributesDialog> | ReturnType<typeof hideCharactersAttributesDialog> | ReturnType<typeof showCharactersCategoryDialog> | ReturnType<typeof hideCharactersCategoryDialog> | ReturnType<typeof startEditingSelectedCharacter> | ReturnType<typeof finishEditingSelectedCharacter> | ReturnType<typeof showCharactersTemplatePicker> | ReturnType<typeof hideCharactersTemplatePicker> | ReturnType<typeof startCreatingCharacter> | ReturnType<typeof finishCreatingCharacter> | ReturnType<typeof setCharacterTemplateData> | ReturnType<typeof showCharacterFilter> | ReturnType<typeof hideCharacterFilter> | ReturnType<typeof showCharacterSort> | ReturnType<typeof hideCharacterSort> | ReturnType<typeof showCharacterDetails> | ReturnType<typeof hideCharacterDetails> | ReturnType<typeof startDeletingCharacter> | ReturnType<typeof finishDeletingCharacter> | ReturnType<typeof startRemovingTemplateFromCharacter> | ReturnType<typeof finishRemovingTemplateFromCharacter> | ReturnType<typeof setTemplateToRemoveFromCharacter> | ReturnType<typeof setActiveCharacterTab> | ReturnType<typeof showCharacterEditorTemplatePicker> | ReturnType<typeof hideCharacterEditorTemplatePicker> | ReturnType<typeof startEditingOutlineCard> | ReturnType<typeof finishEditingOutlineCard> | ReturnType<typeof setEditingBeatTitleId> | ReturnType<typeof openRestructureTimelineModal> | ReturnType<typeof closeRestructureTimelineModal> | ReturnType<typeof editSelectedTag> | ReturnType<typeof finishEditingSelectedTag> | ReturnType<typeof toggleReplaceSearch> | ReturnType<typeof setReplacementText> | ReturnType<typeof _toggleHitMarkedForReplacement> | ReturnType<typeof _startSearching> | ReturnType<typeof _replaceMarkedHits> | ReturnType<typeof _startViewing> | ReturnType<typeof setReplaceWord> | ReturnType<typeof startScanningSearch> | ReturnType<typeof startEditingBeatHeadingTitle> | ReturnType<typeof stopEditingBeatHeadingTitle> | ReturnType<typeof startEditingPlotlineHeadingTitle> | ReturnType<typeof stopEditingPlotlineHeadingTitle> | ReturnType<typeof setDashboardModalView> | ReturnType<typeof toggleIdMarkedToImport> | ReturnType<typeof toggleAllSectionMarkedToImport> | ReturnType<typeof toggleBookToImport> | ReturnType<typeof toggleCustomAttributeToImport> | ReturnType<typeof closeImportPltrModal> | ReturnType<typeof _showImportDataPicker> | ReturnType<typeof showProAccountRecentFiles> | ReturnType<typeof closeConflictResolutionModal> | ReturnType<typeof setOutlineView> | ReturnType<typeof showFulltextLayoutConfig> | ReturnType<typeof closeFulltextLayoutConfig> | ReturnType<typeof showFulltextCardTitle> | ReturnType<typeof showFulltextBeatTitle> | ReturnType<typeof setFulltextLighterPlotlinePageColor> | ReturnType<typeof addOutlineFulltextZoom> | ReturnType<typeof reduceOutlineFulltextZoom> | ReturnType<typeof showFulltextCardHoverDetails> | ReturnType<typeof hideFulltextCardHoverDetails> | ReturnType<typeof toggleFulltextShowBeatGaps> | ReturnType<typeof setFulltextBeatTitleAlignment> | ReturnType<typeof setFulltextCardTitleAlignment> | ReturnType<typeof setOutlineDetailsPinned> | ReturnType<typeof togglePlotlineCardColorSource> | ReturnType<typeof toggleSmallTimelinePlotlineCardColorSource> | ReturnType<typeof deselectCharacterForChangingImage> | ReturnType<typeof selectCharacterForChangingImage> | ReturnType<typeof openRelationshipEditor> | ReturnType<typeof closeRelationshipEditor> | ReturnType<typeof selectRelationshipType> | ReturnType<typeof showRelationshipEditorColourPicker> | ReturnType<typeof hideRelationshipEditorColourPicker> | ReturnType<typeof startEditingFamilyTreeNameById> | ReturnType<typeof selectFamilyTree> | ReturnType<typeof finishEditingFamilyTreeName> | ReturnType<typeof _setSearchModalActiveTab> | ReturnType<typeof _openSearch> | ReturnType<typeof _openReplace> | ReturnType<typeof openSearchModalToBookmarks> | ReturnType<typeof setFamilyTreeScale> | ReturnType<typeof setFamilyTreePosition> | ReturnType<typeof openDocumentationModal> | ReturnType<typeof closeDocumentationModal> | ReturnType<typeof showQuickEditModal> | ReturnType<typeof closeQuickEditModal> | ReturnType<typeof showPreviewPanels> | ReturnType<typeof hidePreviewPanels> | ReturnType<typeof pinCard> | ReturnType<typeof unpinCard> | ReturnType<typeof pinNote> | ReturnType<typeof unpinNote> | ReturnType<typeof floatPreviewPanel> | ReturnType<typeof pinCharacter> | ReturnType<typeof unpinCharacter> | ReturnType<typeof pinPlace> | ReturnType<typeof unpinPlace> | ReturnType<typeof toggleExpandPreviewPanel> | ReturnType<typeof toggleMinimizePreviewPanel> | ReturnType<typeof savePreviewPanelCoords> | ReturnType<typeof unpinAllPreviewPanels> | ReturnType<typeof openPreviewPanelConfirmModal> | ReturnType<typeof setPreviewPanelShrink> | ReturnType<typeof addCharacterToBookmarks> | ReturnType<typeof removeCharacterFromBookmarks> | ReturnType<typeof addNoteToBookmarks> | ReturnType<typeof removeNoteFromBookmarks> | ReturnType<typeof addPlaceToBookmarks> | ReturnType<typeof removePlaceFromBookMarks> | ReturnType<typeof _addCardToBookmarks> | ReturnType<typeof removeCardFromBookmarks> | ReturnType<typeof showIdeaBoard> | ReturnType<typeof hideIdeaBoard> | ReturnType<typeof showIdeaBoardPreviewModal> | ReturnType<typeof closeIdeaBoardPreviewModal> | ReturnType<typeof saveNewIdea> | ReturnType<typeof editIdea> | ReturnType<typeof toggleShowIdeaSearchBar> | ReturnType<typeof deleteIdea> | ReturnType<typeof _closeIdeaBoardPreviewModal> | ReturnType<typeof _hideIdeaBoard> | ReturnType<typeof _openTempCardModal> | ReturnType<typeof openConfirmDeleteIdeaModal> | ReturnType<typeof _closeIdeaConfirmModal> | ReturnType<typeof _addPlaceFromIdeaBoard> | ReturnType<typeof _addNoteFromIdeaBoard> | ReturnType<typeof closeConfirmIdeaModal> | ReturnType<typeof toggleShowPanelsWithIdeaBoard> | ReturnType<typeof toggleShowCollapsibleIdeaCardDescription> | ReturnType<typeof toggleCollapseBookmarkKind> | ReturnType<typeof _setCardDialogOpen> | ReturnType<typeof load> | ReturnType<typeof expandCharacterCategories> | ReturnType<typeof collapseCharacterCategories> | ReturnType<typeof toggleCharactersTabListView> | ReturnType<typeof expandPlaceCategories> | ReturnType<typeof collapsePlaceCategories> | ReturnType<typeof togglePlacesTabListView> | ReturnType<typeof expandNoteCategories> | ReturnType<typeof collapseNoteCategories> | ReturnType<typeof toggleNotesTabListView>  | ReturnType<typeof setTheme> | ReturnType<typeof showMobileControlsModal> | ReturnType<typeof hideMobileControlsModal> |ReturnType<typeof setCharacterCategoryFilter> | ReturnType<typeof setPlaceCategoryFilter> | ReturnType<typeof setNoteCategoryFilter> | ReturnType<typeof showTimelineFilterList> | ReturnType<typeof hideTimelineFilterList> | AddCharacterFromIdeaBoardAction | ResetTimelineAction | ClearTemplateFromTimeline | ChangeCurrentTimelineAction} UiActionsWithoutMetadata
 */

/**
 * @typedef UiActionsMetadata
 * @property {boolean} [currentlyShouldBeLoggedIn]
 * @property {String} [currentUserId]
 * @property {FilePermission} [currentPermission]
 */

/**
 * @typedef {UiActionsWithoutMetadata & UiActionsMetadata} UiActions
 */

const {
  allCardsSelector,
  fileURLSelector,
  searchDialogCurrentHitIndexSelector,
  flatSearchHitsSelector,
  allCharacterAttributesSelector,
  singleCharacterSelector,
  characterAttributeTabSelector,
  hitsMarkedForReplacementSelector,
  searchReplacementTextSelector,
  allBooksSelector,
  seriesSelector,
  allNotesSelector,
  allPlacesSelector,
  allTagsSelector,
  allLinesSelector,
  allBeatsAsArraySelector,
  displayedSingleCharacterSelector,
  allBooksAsArraySelector,
  cardsCustomAttributesSelector,
  allCharactersSelector,
  allBeatsSelector,
  allHierarchyLevelsSelector,
  imagesSelector,
  characterCustomAttributesSelector,
  placeCustomAttributesSelector,
  noteCustomAttributesSelector,
  currentViewSelector,
  outlineViewSelector,
  allPreviewPanelsAsFlatArraySelector,
  beatByIdSelector,
  singleIdeaSelector,
  ideaConfirmModalSelector,
  ideaBoardModalSelector,
  currentTimelineSelector,
} = selectors(identity)
import { nextId } from '../store/newIds'

/**
 * @param {PlottrTab} view
 * @return {{ type: 'CHANGE_CURRENT_VIEW', view: PlottrTab }}
 */
export function changeCurrentView(view) {
  return { type: CHANGE_CURRENT_VIEW, view }
}

/**
 * @param {TimelineOrientation} orientation
 * @return {{ type: 'CHANGE_ORIENTATION', orientation: TimelineOrientation }}
 */
export function changeOrientation(orientation) {
  return { type: CHANGE_ORIENTATION, orientation }
}

/**
 * @param {String} fileName
 * @param {boolean} dirty
 * @param {PlottrFile} payload
 * @param {String} version
 * @param {String} fileURL
 * @return {{ type: 'FILE_LOADED', fileName: String, dirty: boolean, data: PlottrFile, version: String, fileURL: String }}
 */
export function loadFile(fileName, dirty, payload, version, fileURL) {
  return { type: FILE_LOADED, data: payload, fileName, dirty, version, fileURL }
}

/**
 * @param {String} fileName
 * @param {String} version
 * @return {{ type: 'NEW_FILE', fileName: String, version: String }}
 */
export function newFile(fileName, version) {
  return { type: NEW_FILE, fileName, version }
}

/**
 * @return {{ type: 'FILE_SAVED', dirty: false }}
 */
export function fileSaved() {
  return { type: FILE_SAVED, dirty: false }
}

/**
 * @typedef {'asc' | 'desc'} SortDirection
 */

/**
 * @param {String} attr
 * @param {SortDirection} direction
 * @return {{ type: 'SET_CHARACTER_SORT', attr: String, direction: SortDirection }}
 */
export function setCharacterSort(attr, direction) {
  return { type: SET_CHARACTER_SORT, attr, direction }
}

/**
 * @param {String} attr
 * @param {SortDirection} direction
 * @return {{ type: 'SET_PLACE_SORT', attr: String, direction: SortDirection }}
 */
export function setPlaceSort(attr, direction) {
  return { type: SET_PLACE_SORT, attr, direction }
}

/**
 * @param {String} attr
 * @param {SortDirection} direction
 * @return {{ type: 'SET_NOTE_SORT', attr: String, direction: SortDirection }}
 */
export function setNoteSort(attr, direction) {
  return { type: SET_NOTE_SORT, attr, direction }
}

/**
 * @param {Record<String, Array<String>> | Null} filter
 * @return {{ type: 'SET_CHARACTER_FILTER', filter: Record<String, Array<String>> | Null }}
 */
export function setCharacterFilter(filter) {
  return { type: SET_CHARACTER_FILTER, filter }
}

/**
 * @param {Record<String, Array<String>> | Null} filter
 * @return {{ type: 'SET_PLACE_FILTER', filter: Record<String, Array<String>> | Null }}
 */
export function setPlaceFilter(filter) {
  return { type: SET_PLACE_FILTER, filter }
}

/**
 * @param {Record<String, Array<String>> | Null} filter
 * @return {{ type: 'SET_NOTE_FILTER', filter: Record<String, Array<String>> | Null }}
 */
export function setNoteFilter(filter) {
  return { type: SET_NOTE_FILTER, filter }
}

/**
 * @param {Number | Null} filter
 * @return {{ type: 'SET_CHARACTER_CATEGORY_FILTER', filter: Number | Null }}
 */
export function setCharacterCategoryFilter(filter) {
  return { type: SET_CHARACTER_CATEGORY_FILTER, filter }
}

/**
 * @param {Number | Null} filter
 * @return {{ type: 'SET_PLACE_CATEGORY_FILTER', filter: Number | Null }}
 */
export function setPlaceCategoryFilter(filter) {
  return { type: SET_PLACE_CATEGORY_FILTER, filter }
}

/**
 * @param {Number | Null} filter
 * @return {{ type: 'SET_NOTE_CATEGORY_FILTER', filter: Number | Null }}
 */
export function setNoteCategoryFilter(filter) {
  return { type: SET_NOTE_CATEGORY_FILTER, filter }
}

/**
 * @param {Record<String, Array<String>> | Null} filter
 * @return {{ type: 'SET_TIMELINE_FILTER', filter: Record<String, Array<String>> | Null }}
 */
export function setTimelineFilter(filter) {
  return { type: SET_TIMELINE_FILTER, filter }
}

/**
 * @param {Record<String, Array<number>> | number | Null} filter
 * @return {{ type: 'SET_OUTLINE_FILTER', filter: Record<String, Array<number>> | number | Null }}
 */
export function setOutlineFilter(filter) {
  return { type: SET_OUTLINE_FILTER, filter }
}

/**
 * @param {number | 'series'} id
 * @return {{ type: 'CHANGE_CURRENT_TIMELINE', id: number | 'series' }}
 */
export function changeCurrentTimeline(id) {
  return { type: CHANGE_CURRENT_TIMELINE, id }
}

/**
 * @param {number | 'series'} bookId
 * @param {boolean} inBrowser
 * @param {{ push: function(String): Void }} history
 * @return {{ type: 'NAVIGATE_TO_BOOK_TIMELINE', bookId: number | 'series' }}
 */
export function navigateToBookTimeline(bookId, inBrowser, history) {
  if (inBrowser && history) {
    history.push(`/timeline`)
  }

  return { type: NAVIGATE_TO_BOOK_TIMELINE, bookId }
}

/**
 * @return {{ type: 'EXPAND_TIMELINE' }}
 */
export function expandTimeline() {
  return { type: EXPAND_TIMELINE }
}

/**
 * @return {{ type: 'COLLAPSE_TIMELINE' }}
 */
export function collapseTimeline() {
  return { type: COLLAPSE_TIMELINE }
}

/**
 * @param {number | 'series'} bookId
 * @param {String} templateId
 * @return {{ type: 'CLEAR_TEMPLATE_FROM_TIMELINE', bookId: number | 'series', templateId: String }}
 */
export function clearTemplateFromTimeline(bookId, templateId) {
  return { type: CLEAR_TEMPLATE_FROM_TIMELINE, bookId, templateId }
}

/**
 * @param {number | 'series'} bookId
 * @return {{ type: 'RESET_TIMELINE', bookId: number | 'series' }}
 */
export function resetTimeline(bookId) {
  return { type: RESET_TIMELINE, bookId }
}

/**
 * @param {{ x: number, y: number }} coord
 * @return {{ type: 'RECORD_TIMELINE_SCROLL_POSITION', x: number, y: number }}
 */
export function recordTimelineScrollPosition({ x, y }) {
  return { type: RECORD_TIMELINE_SCROLL_POSITION, x, y }
}

/**
 * @return {{ type: 'SHOW_TIMELINE_FILTER_LIST' }}
 */
export function showTimelineFilterList() {
  return { type: SHOW_TIMELINE_FILTER_LIST }
}

/**
 * @return {{ type: 'HIDE_TIMELINE_FILTER_LIST' }}
 */
export function hideTimelineFilterList() {
  return { type: HIDE_TIMELINE_FILTER_LIST }
}

/**
 * @param {number} position
 * @return {{ type: 'RECORD_OUTLINE_SCROLL_POSITION', position: number }}
 */
export function recordOutlineScrollPosition(position) {
  return { type: RECORD_OUTLINE_SCROLL_POSITION, position }
}

/**
 * @param {number} position
 * @return {{ type: 'RECORD_OUTLINE_PLAN_SCROLL_POSITION', position: number }}
 */
export function recordOutlinePlanScrollPosition(position) {
  return { type: RECORD_OUTLINE_PLAN_SCROLL_POSITION, position }
}

/**
 * @param {String} newName
 * @return {{ type: 'EDIT_FILENAME', newName: String }}
 */
export const _editFilename = (newName) => {
  return { type: EDIT_FILENAME, newName }
}

/**
 * @param {function(String, String): Promise<boolean>} persistFileNameChange
 * @param {String} newName
 * @return {function(Dispatch, GetState): Void}
 */
export const editFileName = (persistFileNameChange, newName) => (dispatch, getState) => {
  const state = getState()
  const fileURL = fileURLSelector(state)
  // TODO(ed): dispatch an error for not being able to edit the file name.
  if (fileURL) {
    persistFileNameChange(fileURL, newName).then(() => {
      dispatch(_editFilename(newName))
    })
  } else {
    // TODO(ed): handle the case that we tried to rename and there
    // wasn't a file URL.
  }
}

/**
 * @param {TimelineSize} newSize
 * @return {{ type: 'SET_TIMELINE_SIZE', newSize: TimelineSize }}
 */
export function setTimelineSize(newSize) {
  return { type: SET_TIMELINE_SIZE, newSize }
}

/**
 * @return {{ type: 'OPEN_ATTRIBUTES_DIALOG' }}
 */
export function openAttributesDialog() {
  return { type: OPEN_ATTRIBUTES_DIALOG }
}

/**
 * @return {{ type: 'CLOSE_ATTRIBUTES_DIALOG' }}
 */
export function closeAttributesDialog() {
  return { type: CLOSE_ATTRIBUTES_DIALOG }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_NOTES_SEARCH_TERM', searchTerm: String }}
 */
export function setNotesSearchTerm(searchTerm) {
  return { type: SET_NOTES_SEARCH_TERM, searchTerm }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_CHARACTERS_SEARCH_TERM', searchTerm: String }}
 */
export function setCharactersSearchTerm(searchTerm) {
  return { type: SET_CHARACTERS_SEARCH_TERM, searchTerm }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_PLACES_SEARCH_TERM', searchTerm: String }}
 */
export function setPlacesSearchTerm(searchTerm) {
  return { type: SET_PLACES_SEARCH_TERM, searchTerm }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_TAGS_SEARCH_TERM', searchTerm: String }}
 */
export function setTagsSearchTerm(searchTerm) {
  return { type: SET_TAGS_SEARCH_TERM, searchTerm }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_OUTLINE_SEARCH_TERM', searchTerm: String }}
 */
export function setOutlineSearchTerm(searchTerm) {
  return { type: SET_OUTLINE_SEARCH_TERM, searchTerm }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_TIMELINE_SEARCH_TERM', searchTerm: String }}
 */
export function setTimelineSearchTerm(searchTerm) {
  return { type: SET_TIMELINE_SEARCH_TERM, searchTerm }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_IDEA_SEARCH_TERM', searchTerm: String }}
 */
export function setIdeaSearchterm(searchTerm) {
  return { type: SET_IDEA_SEARCH_TERM, searchTerm }
}

/**
 * @param {boolean} patching
 * @param {PlottrFileFile} file
 * @return {{ type: 'LOAD_FILE', patching: boolean, file: PlottrFileFile }}
 */
export function patchFile(patching, file) {
  return { type: LOAD_FILE, patching, file }
}

/**
 * Sets the tab on the tabbed view of a structured timeline.
 *
 * @param {number} activeTab
 * @return {{ type: 'SET_ACTIVE_TIMELINE_TAB', activeTab: number }}
 */
export function setTimelineActiveTab(activeTab) {
  return { type: SET_ACTIVE_TIMELINE_TAB, activeTab }
}

/**
 * @param {ActView} timelineView
 * @return {{ type: 'SET_TIMELINE_VIEW', timelineView: ActView }}
 */
export function setTimelineView(timelineView) {
  return { type: SET_TIMELINE_VIEW, timelineView }
}

/**
 * @param {'all' | number} bookId
 * @return {{ type: 'SELECT_CHARACTER_ATTRIBUTE_BOOK_TAB', bookId: 'all' | number }}
 */
export function selectCharacterAttributeBookTab(bookId) {
  return { type: SELECT_CHARACTER_ATTRIBUTE_BOOK_TAB, bookId }
}

/**
 * @param {number} id
 * @return {{ type: 'SELECT_CHARACTER', id: number }}
 */
export function selectCharacter(id) {
  return { type: SELECT_CHARACTER, id }
}

/**
 * @param {CharacterView} characterView
 * @return {{ type: 'SET_CHARACTER_VIEW', characterView: CharacterView }}
 */
export function setCharacterView(characterView) {
  return { type: SET_CHARACTER_VIEW, characterView }
}

/**
 * @param {number} cardId
 * @param {number} beatId
 * @param {number} lineId
 * @return {{ type: SET_CARD_DIALOG_OPEN, cardId: number, lineId: number, beatId: number }}
 */
export const _setCardDialogOpen = (cardId, beatId, lineId) => {
  return {
    type: SET_CARD_DIALOG_OPEN,
    cardId,
    beatId,
    lineId,
  }
}

/**
 * @param {number} cardId
 * @param {number} beatId
 * @param {number} lineId
 * @return {function(Dispatch, GetState): Void}
 */
export const setCardDialogOpen = (cardId, beatId, lineId) => (dispatch, getState) => {
  const state = getState()
  const allCards = allCardsSelector(state)
  const cardExists = allCards.find((card) => card.id == cardId)
  if (cardExists) {
    dispatch(_setCardDialogOpen(cardId, beatId, lineId))
  }
}

/**
 * @return {{ type: 'SET_CARD_DIALOG_CLOSE' }}
 */
export function setCardDialogClose() {
  return { type: SET_CARD_DIALOG_CLOSE }
}

/**
 * @return {{ type: 'OPEN_NEW_BOOK_DIALOG' }}
 */
export function openNewBookDialog() {
  return { type: OPEN_NEW_BOOK_DIALOG }
}

/**
 * @param {number | 'series'} bookId
 * @return {{ type: 'OPEN_EDIT_BOOK_DIALOG', bookId: number | 'series' }}
 */
export function openEditBookDialog(bookId) {
  return {
    type: OPEN_EDIT_BOOK_DIALOG,
    bookId,
  }
}

/**
 * @return {{ type: 'CLOSE_BOOK_DIALOG' }}
 */
export function closeBookDialog() {
  return { type: CLOSE_BOOK_DIALOG }
}

/**
 * @return {{ type: 'CLOSE_SEARCH' }}
 */
export function closeSearch() {
  return { type: CLOSE_SEARCH }
}

/**
 * @return {{ type: 'TOGGLE_ADVANCED_SAVE_TEMPLATE_PANEL' }}
 */
export function toggleAdvancedSaveTemplatePanel() {
  return { type: TOGGLE_ADVANCED_SAVE_TEMPLATE_PANEL }
}

/**
 * @return {{ type: 'OPEN_SEARCH' }}
 */
export function openSearch() {
  return { type: OPEN_SEARCH }
}

/**
 * @return {{ type: 'OPEN_REPLACE' }}
 */
export function openReplace() {
  return { type: OPEN_REPLACE }
}

/**
 * @param {number | Null} beatId
 * @return {{ type: 'SET_FOCUSSED_TIMELINE_TAB_BEAT', beatId: number | Null }}
 */
export function setFocussedTimelineTabBeat(beatId) {
  return { type: SET_FOCUSSED_TIMELINE_TAB_BEAT, beatId }
}

/**
 * @param {String} searchTerm
 * @return {{ type: 'SET_BOOKMARKS_SEARCH_TERM', searchTerm: String }}
 */
export function setBookmarksSearchTerm(searchTerm) {
  return { type: SET_BOOKMARKS_SEARCH_TERM, searchTerm }
}

/**
 * @param {Array<SearchHit>} newHits
 * @return {{ type: 'UPDATE_HITS_MARKED_FOR_REPLACEMENT', newHits: Array<SearchHit> }}
 */
export const _updateHitsMarkedForReplacement = (newHits) => {
  return {
    type: UPDATE_HITS_MARKED_FOR_REPLACEMENT,
    newHits,
  }
}

/**
 * @param {String} term
 * @return {{ type: 'SET_SEARCH_TERM', term: String }}
 */
export const _setSearchTerm = (term) => {
  return { type: SET_SEARCH_TERM, term }
}

/**
 * @param {String} term
 * @return {function(Dispatch, GetState): Void}
 */
export function setSearchTerm(term) {
  return function (dispatch, getState) {
    batch('Set Search Term', () => {
      dispatch(_setSearchTerm(term))
      const newState = getState()
      const newHits = flatSearchHitsSelector(newState)
      dispatch(_updateHitsMarkedForReplacement(newHits))
    })(dispatch)
  }
}

/**
 * @param {number | null} beatId
 * @return {{ type: 'SET_TIMELINE_TAB_BEAT_TO_DELETE', beatId: number | Null }}
 */
export function setTimelineTabBeatToDelete(beatId) {
  return { type: SET_TIMELINE_TAB_BEAT_TO_DELETE, beatId }
}

/**
 * @param {number} cardId
 * @return {{ type: 'SELECT_OUTLINE_CARD', cardId: number }}
 */
export function selectOutlineCard(cardId) {
  return { type: SELECT_OUTLINE_CARD, cardId }
}

/**
 * @param {boolean} open
 * @return {{ type: 'SET_ACT_CONFIG_MODAL_OPEN', open: boolean }}
 */
export function setActConfigIsOpen(open) {
  return { type: SET_ACT_CONFIG_MODAL_OPEN, open }
}

/**
 * @param {number} id
 * @return {{ type: 'SELECT_NOTE', id: number }}
 */
export function selectNote(id) {
  return { type: SELECT_NOTE, id }
}

/**
 * @param {number} id
 * @return {{ type: 'SELECT_PLACE', id: number }}
 */
export function selectPlace(id) {
  return { type: SELECT_PLACE, id }
}

/**
 * @param {number} id
 * @return {{ type: 'SELECT_TAG', id: number }}
 */
export function selectTag(id) {
  return { type: SELECT_TAG, id }
}

/**
 * @param {function(): Void} f
 */
const withShortDelay = (f) => setTimeout(f, 0)

/**
 * @return {{ type: 'START_JUMPING' }}
 */
const startJumping = () => {
  return {
    type: START_JUMPING,
  }
}

/**
 * @return {{ type: 'FINISH_JUMPING' }}
 */
const finishJumping = () => {
  return {
    type: FINISH_JUMPING,
  }
}

/**
 * @param {Array<Card>} cards
 * @param {'project' | 'timeline' | 'outline' | 'notes' | 'characters' | 'places' | 'tags' | 'lines' | 'beats'} hitType
 * @param {{ path: String, hit: String }} searchHit
 * @return {function(Dispatch, GetState): Void}
 */
export const jumpToHit = (cards, hitType, searchHit) => (dispatch, getState) => {
  withShortDelay(() => {
    // Note; you should avoid changing any state if we're not going to
    // jump.
    switch (hitType) {
      case 'project': {
        const { path, hit } = searchHit
        const [_, _project, bookOrSeries, ...rest] = path.split('/')
        if (bookOrSeries === 'book') {
          const [id, attribute] = rest
          const bookId = parseNumberOrString(id)
          if ((bookId && typeof bookId === 'number') || bookId === 'series') {
            const book = allBooksSelector(getState())[bookId]
            if (
              typeof book !== 'undefined' &&
              ['title', 'premise', 'genre', 'theme'].indexOf(attribute) !== -1
            ) {
              const focusPath = projectFocusPath(bookId, attribute)
              const focusStart = safeParseInt(rest[rest.length - 1])
              batch('Jump to Project Search Hit', () => {
                dispatch(startJumping())
                dispatch(closeBookDialog())
                dispatch(changeCurrentView('project'))
                dispatch(
                  pushFocus('project', focusPath, {
                    start: focusStart,
                    end: focusStart + hit.length,
                    direction: 'forward',
                  })
                )
                dispatch(openEditBookDialog(bookId))
                dispatch(incrementJumpCounter())
                dispatch(finishJumping())
              })(dispatch)
            }
          }
        } else {
          const [attribute] = rest
          if (['name', 'premise', 'genre', 'theme'].indexOf(attribute) !== -1) {
            const focusPath = projectFocusPath(null, attribute)
            const focusStart = safeParseInt(rest[rest.length - 1])
            batch('Jump to Project Search Hit', () => {
              dispatch(closeBookDialog())
              dispatch(startJumping())
              dispatch(changeCurrentView('project'))
              dispatch(
                pushFocus('project', focusPath, {
                  start: focusStart,
                  end: focusStart + hit.length,
                  direction: 'forward',
                })
              )
              dispatch(incrementJumpCounter())
              dispatch(finishJumping())
            })(dispatch)
          }
        }
        return
      }
      case 'timeline': {
        const { path, hit } = searchHit
        const [_, _timeline, rawBookId, _card, cardId, type, ...rest] = path.split('/')
        const bookId = parseNumberOrString(rawBookId)
        const books = allBooksSelector(getState())
        if (bookId) {
          const book = bookId === 'series' ? seriesSelector(getState()) : books[bookId]
          if (typeof book !== 'undefined') {
            const card = cards.find((card) => {
              // We want a weak comparison here to compare string
              // numbers to numbers.
              //
              // @ts-ignore
              return card.id == cardId
            })
            if (typeof card !== 'undefined') {
              if (type === 'customAttribute') {
                // This is the tab on Card dialog corresponding to custom attributes.
                const attributeName = unescapeUIPathElement(rest[0])
                const focusPath = cardFocusPath(cardId, {
                  customAttributeName: attributeName,
                  baseAttributeName: undefined,
                  template: undefined,
                })
                const focusStart = safeParseInt(rest[rest.length - 1])
                if (typeof card[attributeName] !== 'undefined') {
                  batch('Jump to Timeline Search Hit', () => {
                    dispatch(startJumping())
                    dispatch(changeCurrentView('timeline'))
                    dispatch(
                      // NOTE(ed): we add more attributes in the root reducer
                      //
                      // @ts-ignore
                      changeCurrentTimeline(bookId)
                    )
                    dispatch(
                      pushFocus('timeline', focusPath, {
                        start: focusStart,
                        end: focusStart + hit.length,
                        direction: 'forward',
                      })
                    )
                    dispatch(setActiveTabOnCardDialog(2))
                    dispatch(incrementJumpCounter())
                    setCardDialogOpen(card?.id, card?.beatId, card?.lineId)(dispatch, getState)
                    dispatch(finishJumping())
                  })(dispatch)
                }
              } else if (type === 'templateAttribute') {
                const [templateId, rawAttributeName] = rest
                const attributeName = unescapeUIPathElement(rawAttributeName)
                const template = card.templates.find(({ id }) => {
                  return id === templateId
                })
                if (typeof template !== 'undefined') {
                  const attribute = template.attributes.find(({ name }) => {
                    return name === attributeName
                  })
                  if (typeof attribute !== 'undefined') {
                    const focusStart = safeParseInt(rest[rest.length - 1])
                    const focusPath = cardFocusPath(cardId, {
                      // @ts-ignore
                      template: { id: templateId, attributeName },
                      baseAttributeName: undefined,
                      customAttributeName: undefined,
                    })
                    const indexOfTemplate = card.templates.findIndex((template) => {
                      return template.id === templateId
                    })
                    batch('Jump to Timeline Search Hit', () => {
                      dispatch(startJumping())
                      dispatch(changeCurrentView('timeline'))
                      dispatch(
                        // NOTE(ed): we add more attributes in the root reducer
                        //
                        // @ts-ignore
                        changeCurrentTimeline(bookId)
                      )
                      dispatch(
                        pushFocus('timeline', focusPath, {
                          start: focusStart,
                          end: focusStart + hit.length,
                          direction: 'forward',
                        })
                      )
                      // ASSUME: order of tabs is the same as the order of
                      // templates on the card.
                      dispatch(setActiveTabOnCardDialog(3 + indexOfTemplate))
                      dispatch(incrementJumpCounter())
                      setCardDialogOpen(card?.id, card?.beatId, card?.lineId)(dispatch, getState)
                      dispatch(finishJumping())
                    })(dispatch)
                  }
                }
              } else {
                const baseAttributeName = type
                if (['title', 'description'].indexOf(baseAttributeName) !== -1) {
                  const [rawFocusStart] = rest
                  const focusStart = safeParseInt(rawFocusStart)
                  const focusPath = cardFocusPath(cardId, {
                    baseAttributeName,
                    template: undefined,
                    customAttributeName: undefined,
                  })
                  batch('Jump to Timeline Search Hit', () => {
                    dispatch(startJumping())
                    dispatch(changeCurrentView('timeline'))
                    dispatch(
                      // NOTE(ed): we add more attributes in the root reducer
                      //
                      // @ts-ignore
                      changeCurrentTimeline(bookId)
                    )
                    dispatch(
                      pushFocus('timeline', focusPath, {
                        start: focusStart,
                        end: focusStart + hit.length,
                        direction: 'forward',
                      })
                    )
                    // It's not a template attribute or a custom attribute.
                    // Go to the normal tab.
                    dispatch(setActiveTabOnCardDialog(1))
                    dispatch(incrementJumpCounter())
                    setCardDialogOpen(card?.id, card?.beatId, card?.lineId)(dispatch, getState)
                    dispatch(finishJumping())
                  })(dispatch)
                }
              }
            }
          }
        }
        return
      }
      case 'outline': {
        const { path, hit } = searchHit
        const [_, _outline, view, rawBookId, _card, cardIdAsString, descriptionOrTitle, ...rest] =
          path.split('/')
        const bookId = parseNumberOrString(rawBookId)
        const books = allBooksSelector(getState())
        const currentView = currentViewSelector(getState())
        const currentOutlineView = outlineViewSelector(getState())
        if (bookId) {
          const book = books[bookId]
          if (typeof book !== 'undefined') {
            const cardId = safeParseInt(cardIdAsString)
            const card = cards.find(({ id }) => {
              return id === cardId
            })
            if (
              typeof card !== 'undefined' &&
              ['description', 'title'].indexOf(descriptionOrTitle) !== -1
            ) {
              const focusPath = outlineCardFocusPath(cardId, descriptionOrTitle, view)
              const [rawFocusStart] = rest
              const focusStart = safeParseInt(rawFocusStart)
              batch('Jump to Outline Search Hit', () => {
                dispatch(startJumping())
                dispatch(setCardDialogClose())
                if (currentView !== 'outline') {
                  dispatch(changeCurrentView('outline'))
                }
                if (
                  currentOutlineView !== view &&
                  (view === 'fulltext' || view === 'plan' || view === 'legacy')
                ) {
                  dispatch(setOutlineView(view))
                }
                dispatch(
                  // NOTE(ed): we add more attributes in the root reducer
                  //
                  // @ts-ignore
                  changeCurrentTimeline(bookId)
                )
                dispatch(
                  pushFocus('outline', focusPath, {
                    start: focusStart,
                    end: focusStart + hit.length,
                    direction: 'forward',
                  })
                )
                dispatch(selectOutlineCard(cardId))
                dispatch(startEditingOutlineCard(cardId))
                dispatch(incrementJumpCounter())
                dispatch(finishJumping())
              })(dispatch)
            }
          }
        }
        return
      }
      case 'notes': {
        const { path, hit } = searchHit
        const [_, _notes, noteIdAsString, type, ...rest] = path.split('/')
        const noteId = parseNumberOrString(noteIdAsString)
        const notes = allNotesSelector(getState())
        const note = notes.find(({ id }) => {
          return id === noteId
        })
        if (typeof note !== 'undefined' && typeof noteId === 'number') {
          if (type === 'customAttribute') {
            const [rawAttributeName, rawFocusStart] = rest
            const attributeName = unescapeUIPathElement(rawAttributeName)
            if (typeof note[attributeName] !== 'undefined') {
              const focusStart = safeParseInt(rawFocusStart)
              const focusPath = noteFocusPath(noteId, {
                attributeName,
                contentOrTitle: null,
              })
              batch('Jump to Note Search Hit', () => {
                dispatch(startJumping())
                dispatch(changeCurrentView('notes'))
                dispatch(
                  pushFocus('note', focusPath, {
                    start: focusStart,
                    end: focusStart + hit.length,
                    direction: 'forward',
                  })
                )
                dispatch(selectNote(noteId))
                dispatch(startEditingSelectedNote())
                dispatch(incrementJumpCounter())
                dispatch(finishJumping())
              })(dispatch)
            }
          } else {
            if (typeof note[type] !== 'undefined') {
              const [rawFocusStart] = rest
              const contentOrTitle = type
              const focusStart = safeParseInt(rawFocusStart)
              const focusPath = noteFocusPath(noteId, { contentOrTitle, attributeName: null })
              batch('Jump to Note Search Hit', () => {
                dispatch(startJumping())
                dispatch(changeCurrentView('notes'))
                dispatch(
                  pushFocus('note', focusPath, {
                    start: focusStart,
                    end: focusStart + hit.length,
                    direction: 'forward',
                  })
                )
                dispatch(selectNote(noteId))
                dispatch(startEditingSelectedNote())
                dispatch(incrementJumpCounter())
                dispatch(finishJumping())
              })(dispatch)
            }
          }
        }
        return
      }
      case 'characters': {
        const { path, hit } = searchHit
        const [_, _characters, rawCharacterId, type, ...rest] = path.split('/')
        const characterId = parseNumberOrString(rawCharacterId)
        if (typeof characterId === 'number') {
          const character = displayedSingleCharacterSelector(getState(), characterId)
          if (character === null || typeof character === 'undefined') {
            return
          } else if (type === 'customAttribute') {
            const [rawAttributeId, rawBookId, rawFocusStart] = rest
            const focusStart = safeParseInt(rawFocusStart)
            const attributeId = parseNumberOrString(rawAttributeId)
            const tabBookId = parseNumberOrString(rawBookId)
            const state = getState()
            const characterAttributes = allCharacterAttributesSelector(state)
            const attributeType = characterAttributes.find(({ id }) => {
              return id === attributeId
            })?.type
            const allBooks = allBooksSelector(state)
            const series = seriesSelector(state)
            if (tabBookId && (tabBookId === 'all' || typeof tabBookId === 'number')) {
              const book = tabBookId === 'all' ? series : allBooks[tabBookId]
              if (typeof book !== 'undefined' && typeof attributeType !== 'undefined') {
                batch('Jump to Character Search Hit', () => {
                  dispatch(startJumping())
                  dispatch(selectCharacterAttributeBookTab(tabBookId))
                  dispatch(hideCharacterDetails())
                  dispatch(changeCurrentView('characters'))
                  dispatch(selectCharacter(characterId))
                  dispatch(startEditingSelectedCharacter())
                  // 2 is the id of the attributes tab in `CharacterEditDetails`
                  if (attributeType === 'base-attribute') {
                    dispatch(setActiveCharacterTab(1))
                  } else {
                    dispatch(setActiveCharacterTab(2))
                  }
                  const focusPath = characterFocusPath(characterId, tabBookId, {
                    attributeId: String(attributeId),
                    attributeName: null,
                    type: null,
                    templateId: null,
                  })
                  dispatch(
                    pushFocus('character', focusPath, {
                      start: focusStart,
                      end: focusStart + hit.length,
                      direction: 'forward',
                    })
                  )
                  dispatch(incrementJumpCounter())
                  dispatch(showCharacterDetails())
                  dispatch(finishJumping())
                })(dispatch)
              } else if (
                typeof book !== 'undefined' &&
                typeof attributeType === 'undefined' &&
                typeof character[unescapeUIPathElement(rawAttributeId)] !== 'undefined'
              ) {
                const attributeName = unescapeUIPathElement(rawAttributeId)
                batch('Jump to Character Search Hit', () => {
                  dispatch(startJumping())
                  dispatch(selectCharacterAttributeBookTab(tabBookId))
                  dispatch(hideCharacterDetails())
                  dispatch(changeCurrentView('characters'))
                  dispatch(selectCharacter(characterId))
                  dispatch(startEditingSelectedCharacter())
                  // 2 is the id of the attributes tab in `CharacterEditDetails`
                  if (['description', 'notes'].includes(rawAttributeId)) {
                    dispatch(setActiveCharacterTab(1))
                  } else {
                    dispatch(setActiveCharacterTab(2))
                  }
                  const focusPath = characterFocusPath(characterId, tabBookId, {
                    attributeId: attributeName,
                    templateId: null,
                    attributeName: null,
                    type: null,
                  })
                  dispatch(
                    pushFocus('character', focusPath, {
                      start: focusStart,
                      end: focusStart + hit.length,
                      direction: 'forward',
                    })
                  )
                  dispatch(incrementJumpCounter())
                  dispatch(showCharacterDetails())
                  dispatch(finishJumping())
                })(dispatch)
              }
            }
          } else if (type === 'templateAttribute') {
            const [templateId, rawAttributeName, rawBookId, rawFocusStart] = rest
            const attributeName = unescapeUIPathElement(rawAttributeName)
            const currentCharacterAttributeBookTab = characterAttributeTabSelector(getState())
            const bookId = parseNumberOrString(rawBookId)
            const allBooks = allBooksSelector(getState())
            if (bookId && (bookId === 'all' || typeof bookId === 'number')) {
              const book = bookId === 'all' ? 'series' : allBooks[bookId]
              if (typeof book !== 'undefined') {
                const character = singleCharacterSelector(getState(), characterId)
                if (character) {
                  const template = character.templates.find(({ id }) => {
                    return id === templateId
                  })
                  if (typeof template !== 'undefined') {
                    const templateTab = character.templates.findIndex((template) => {
                      return template.id === templateId
                    })
                    const attribute = template.attributes.find(({ name }) => {
                      return name === attributeName
                    })
                    if (typeof attribute !== 'undefined') {
                      const focusPath = characterFocusPath(characterId, bookId, {
                        templateId,
                        attributeName,
                        attributeId: null,
                        type: null,
                      })
                      const focusStart = safeParseInt(rawFocusStart)
                      batch('Jump to Character Search Hit', () => {
                        dispatch(startJumping())
                        if (currentCharacterAttributeBookTab !== bookId) {
                          dispatch(selectCharacterAttributeBookTab(bookId))
                        }
                        dispatch(hideCharacterDetails())
                        dispatch(changeCurrentView('characters'))
                        dispatch(selectCharacter(characterId))
                        dispatch(startEditingSelectedCharacter())
                        dispatch(
                          pushFocus('character', focusPath, {
                            start: focusStart,
                            end: focusStart + hit.length,
                            direction: 'forward',
                          })
                        )
                        if (templateTab !== -1) {
                          dispatch(setActiveCharacterTab(templateTab + 3))
                        }
                        dispatch(incrementJumpCounter())
                        dispatch(showCharacterDetails())
                        dispatch(finishJumping())
                      })(dispatch)
                    }
                  }
                }
              }
            }
          } else {
            batch('Jump to Character Search Hit', () => {
              dispatch(startJumping())
              dispatch(hideCharacterDetails())
              dispatch(changeCurrentView('characters'))
              dispatch(selectCharacter(characterId))
              dispatch(startEditingSelectedCharacter())
              const [rawFocusStart] = rest
              const focusStart = safeParseInt(rawFocusStart)
              const focusPath = characterFocusPath(characterId, 'all', {
                type,
                templateId: null,
                attributeName: null,
                attributeId: null,
              })
              dispatch(
                pushFocus('character', focusPath, {
                  start: focusStart,
                  end: focusStart + hit.length,
                  direction: 'forward',
                })
              )
              dispatch(incrementJumpCounter())
              dispatch(showCharacterDetails())
              dispatch(finishJumping())
            })(dispatch)
          }
        }
        return
      }
      case 'places': {
        const { path, hit } = searchHit
        const [_, _places, rawPlaceId, type, ...rest] = path.split('/')
        const placeId = safeParseInt(rawPlaceId)
        const places = allPlacesSelector(getState())
        const place = places.find(({ id }) => {
          return id === placeId
        })
        if (typeof place !== 'undefined') {
          if (type === 'customAttribute') {
            const [rawCustomAttributeName, rawFocusStart] = rest
            const customAttributeName = unescapeUIPathElement(rawCustomAttributeName)
            const focusPath = placeFocusPath(placeId, {
              customAttributeName,
              type: null,
            })
            const focusStart = safeParseInt(rawFocusStart)
            if (typeof place[customAttributeName] !== 'undefined') {
              batch('Jump to Place Search Hit', () => {
                dispatch(startJumping())
                dispatch(changeCurrentView('places'))
                dispatch(selectPlace(placeId))
                dispatch(
                  pushFocus('place', focusPath, {
                    start: focusStart,
                    end: focusStart + hit.length,
                    direction: 'forward',
                  })
                )
                dispatch(startEditingSelectedPlace())
                dispatch(incrementJumpCounter())
                dispatch(finishJumping())
              })(dispatch)
            }
          } else {
            const [rawFocusStart] = rest
            const focusStart = safeParseInt(rawFocusStart)
            const focusPath = placeFocusPath(placeId, { type, customAttributeName: null })
            if (typeof place[type] !== 'undefined') {
              batch('Jump to Place Search Hit', () => {
                dispatch(startJumping())
                dispatch(startEditingSelectedPlace())
                dispatch(incrementJumpCounter())
                dispatch(
                  pushFocus('place', focusPath, {
                    start: focusStart,
                    end: focusStart + hit.length,
                    direction: 'forward',
                  })
                )
                dispatch(changeCurrentView('places'))
                dispatch(selectPlace(placeId))
                dispatch(finishJumping())
              })(dispatch)
            }
          }
        }
        return
      }
      case 'tags': {
        const { path, hit } = searchHit
        const [_, _tags, rawTagId, type, rawFocusStart] = path.split('/')
        const focusStart = safeParseInt(rawFocusStart)
        const tagId = safeParseInt(rawTagId)
        const tags = allTagsSelector(getState())
        const tag = tags.find(({ id }) => {
          return id === tagId
        })
        if (typeof tag !== 'undefined' && typeof tag[type] !== 'undefined') {
          batch('Jump to Tag Search Hit', () => {
            dispatch(startJumping())
            dispatch(changeCurrentView('tags'))
            dispatch(selectTag(tagId))
            dispatch(editSelectedTag())
            const focusPath = tagFocusPath(tagId, type)
            dispatch(
              pushFocus('tag', focusPath, {
                start: focusStart,
                end: focusStart + hit.length,
                direction: 'forward',
              })
            )
            dispatch(incrementJumpCounter())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      case 'lines': {
        const { path, hit } = searchHit
        const [_, _lines, rawLineId, type, rawFocusStart] = path.split('/')
        const focusStart = safeParseInt(rawFocusStart)
        const lineId = safeParseInt(rawLineId)
        const lines = allLinesSelector(getState())
        const line = lines.find(({ id }) => {
          return id === lineId
        })
        if (typeof line !== 'undefined' && typeof line[type] !== 'undefined') {
          batch('Jump to Line Search Hit', () => {
            dispatch(startJumping())
            dispatch(setCardDialogClose())
            dispatch(changeCurrentView('timeline'))
            dispatch(
              // NOTE(ed): we add more attributes in the root reducer
              //
              // @ts-ignore
              changeCurrentTimeline(line.bookId)
            )
            dispatch(startEditingPlotlineHeadingTitle(line.id))
            const focusPath = lineFocusPath(lineId, type)
            dispatch(
              pushFocus('line', focusPath, {
                start: focusStart,
                end: focusStart + hit.length,
                direction: 'forward',
              })
            )
            dispatch(incrementJumpCounter())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      case 'beats': {
        const { path, hit } = searchHit
        const [_, _beats, rawBookId, rawBeatId, type, rawFocusStart] = path.split('/')
        const focusStart = safeParseInt(rawFocusStart)
        const beatId = safeParseInt(rawBeatId)
        const bookId = parseNumberOrString(rawBookId)
        const books = allBooksAsArraySelector(getState())
        const book =
          bookId === 'series'
            ? seriesSelector(getState())
            : books.find(({ id }) => {
                return id === bookId
              })
        const beats = allBeatsAsArraySelector(getState())
        const beat = beats.find(({ id }) => {
          return id === beatId
        })
        if (
          (bookId === 'series' || typeof bookId === 'number') &&
          typeof book !== 'undefined' &&
          typeof beat !== 'undefined' &&
          typeof beat[type] !== 'undefined'
        ) {
          batch('Jump to Beat Search Hit', () => {
            dispatch(startJumping())
            dispatch(setCardDialogClose())
            dispatch(changeCurrentView('timeline'))
            dispatch(
              // NOTE(ed): we add more attributes in the root reducer
              //
              // @ts-ignore
              changeCurrentTimeline(bookId)
            )
            dispatch(startEditingBeatHeadingTitle(beat.id))
            const focusPath = beatFocusPath(beatId, bookId, type)
            dispatch(
              pushFocus('beat', focusPath, {
                start: focusStart,
                end: focusStart + hit.length,
                direction: 'forward',
              })
            )
            dispatch(incrementJumpCounter())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      default: {
        return
      }
    }
  })
}

/**
 * @param {'cards' | 'notes' | 'characters' | 'places' | 'tags' | 'books'} hitType
 * @param {number} ideaId
 * @return {function(Dispatch, GetState): Void}
 */
export const jumpFromChipToItem = (hitType, ideaId) => (dispatch, getState) => {
  withShortDelay(() => {
    // Note; you should avoid changing any state if we're not going to
    // jump.
    switch (hitType) {
      case 'cards': {
        const cards = allCardsSelector(getState())
        const card = cards.find((c) => {
          return c.id == ideaId
        })
        const beat = card ? beatByIdSelector(getState(), card.beatId) : null
        if (card && beat) {
          const bookId = beat.bookId
          if (typeof bookId !== 'undefined' && typeof card !== 'undefined') {
            batch('Navigate to Scene Card', () => {
              dispatch(startJumping())
              dispatch(changeCurrentView('timeline'))
              dispatch(
                // NOTE(ed): we add more attributes in the root reducer
                //
                // @ts-ignore
                changeCurrentTimeline(bookId)
              )

              // It's not a template attribute or a custom attribute.
              // Go to the normal tab.
              dispatch(setActiveTabOnCardDialog(1))
              dispatch(incrementJumpCounter())
              setCardDialogOpen(card?.id, card?.beatId, card?.lineId)(dispatch, getState)
              dispatch(finishJumping())
            })(dispatch)
          }
        }
        return
      }
      case 'notes': {
        const notes = allNotesSelector(getState())
        const note = notes.find(({ id }) => {
          return id === ideaId
        })
        if (typeof note !== 'undefined') {
          batch('Navigate to Note', () => {
            dispatch(startJumping())
            dispatch(changeCurrentView('notes'))
            dispatch(selectNote(ideaId))
            dispatch(incrementJumpCounter())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      case 'characters': {
        const character = displayedSingleCharacterSelector(
          getState(),
          // @ts-ignore
          ideaId
        )
        if (character === null || typeof character === 'undefined') {
          return
        } else {
          batch('Navigate to Character', () => {
            dispatch(startJumping())
            dispatch(hideCharacterDetails())
            dispatch(changeCurrentView('characters'))
            dispatch(selectCharacter(ideaId))
            dispatch(incrementJumpCounter())
            dispatch(showCharacterDetails())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      case 'places': {
        const places = allPlacesSelector(getState())
        const place = places.find(({ id }) => {
          return id === ideaId
        })
        if (typeof place !== 'undefined') {
          batch('Navigate to Place', () => {
            dispatch(startJumping())
            dispatch(incrementJumpCounter())
            dispatch(changeCurrentView('places'))
            dispatch(selectPlace(ideaId))
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      case 'tags': {
        const tags = allTagsSelector(getState())
        const tag = tags.find(({ id }) => {
          return id === ideaId
        })
        if (typeof tag !== 'undefined') {
          batch('Navigate to Tag', () => {
            dispatch(startJumping())
            dispatch(changeCurrentView('tags'))
            dispatch(selectTag(ideaId))
            dispatch(editSelectedTag())
            dispatch(incrementJumpCounter())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      case 'books': {
        const book = allBooksSelector(getState())[ideaId]
        if (typeof book !== 'undefined') {
          batch('Navigate to Book', () => {
            dispatch(startJumping())
            dispatch(closeBookDialog())
            dispatch(changeCurrentView('project'))
            dispatch(openEditBookDialog(ideaId))
            dispatch(incrementJumpCounter())
            dispatch(finishJumping())
          })(dispatch)
        }
        return
      }
      default: {
        return
      }
    }
  })
}

/**
 * @param {String} section
 * @param {Array<String | number | Null>} path
 * @param {DOMSelection | SlateSelection} selection
 * @return {{ type: PUSH_FOCUS, section: String, path: Array<String | number | Null>, selection: DOMSelection | SlateSelection }}
 */
export const _pushFocus = (section, path, selection) => {
  return { type: PUSH_FOCUS, section, path, selection }
}

// Where "section" is one of "project", "timeline", "outline", "note",
// "character", "place", "tag", "line", or "beat".
/**
 * @typedef SlatePoint
 * @property {Array<number>} path
 * @property {number} offset
 * @param {String} section
 * @param {Array<String | number | Null>} path
 * @param {DOMSelection | SlateSelection} selection
 * @return {function(Dispatch): Void}
 */
export const pushFocus = (section, path, selection) => (dispatch) => {
  const sectionIsValid =
    ['project', 'timeline', 'outline', 'note', 'character', 'place', 'tag', 'line', 'beat'].indexOf(
      section
    ) !== -1
  const pathIsValid = Array.isArray(path) && path[0] !== 'unknown'
  // TODO: why isn't the typedef working here?
  const selectionIsValid =
    isObject(selection) &&
    // @ts-ignore
    ((typeof selection.start === 'number' &&
      // @ts-ignore
      typeof selection.end === 'number' &&
      // @ts-ignore
      typeof selection.direction === 'string') ||
      // @ts-ignore
      (isObject(selection.anchor) &&
        // @ts-ignore
        isObject(selection.focus) &&
        Array.isArray(
          // @ts-ignore
          selection.anchor.path
        ) &&
        // @ts-ignore
        typeof selection.anchor.offset === 'number' &&
        // @ts-ignore
        typeof selection.focus.offset === 'number' &&
        Array.isArray(
          // @ts-ignore
          selection.focus.path
        )))
  if (sectionIsValid && pathIsValid && selectionIsValid) {
    dispatch(_pushFocus(section, path, selection))
  }
}

/**
 * @return {{ type: 'NEXT_SEARCH_HIT' }}
 */
export const _nextSearchHit = () => {
  return { type: NEXT_SEARCH_HIT }
}

/**
 * @return {function(Dispatch, GetState): Void}
 */
export const nextSearchHit = () => (dispatch, getState) => {
  const state = getState()
  const searchHits = flatSearchHitsSelector(state)
  const cards = allCardsSelector(state)
  const allHitsLength = searchHits.length
  const currentHitIndex = searchDialogCurrentHitIndexSelector(state) ?? 0
  const nextHitIndex = currentHitIndex + 1 < allHitsLength ? currentHitIndex + 1 : currentHitIndex
  batch('Jump to Next Search Hit', () => {
    if (currentHitIndex + 1 < allHitsLength) {
      dispatch(_nextSearchHit())
    }
    const hit = searchHits[nextHitIndex]
    const [_, hitType] = hit.path.split('/')
    if (
      hitType === 'project' ||
      hitType === 'timeline' ||
      hitType === 'outline' ||
      hitType === 'notes' ||
      hitType === 'characters' ||
      hitType === 'places' ||
      hitType === 'tags' ||
      hitType === 'lines' ||
      hitType === 'beats'
    ) {
      jumpToHit(cards, hitType, hit)(dispatch, getState)
    }
  })(dispatch)
}

/**
 * @return {{ type: 'PREVIOUS_SEARCH_HIT' }}
 */
export const _previousSearchHit = () => {
  return { type: PREVIOUS_SEARCH_HIT }
}

/**
 * @return {function(Dispatch, GetState): Void}
 */
export const previousSearchHit = () => (dispatch, getState) => {
  const state = getState()
  const cards = allCardsSelector(state)
  const searchHits = flatSearchHitsSelector(state)
  const currentHitIndex = searchDialogCurrentHitIndexSelector(state) ?? 0
  const nextHitIndex = currentHitIndex - 1 >= 0 ? currentHitIndex - 1 : currentHitIndex
  batch('Jump to Previous Search Hit', () => {
    if (currentHitIndex - 1 >= 0) {
      dispatch(_previousSearchHit())
    }
    const hit = searchHits[nextHitIndex]
    const [_, hitType] = hit.path.split('/')
    if (
      hitType === 'project' ||
      hitType === 'timeline' ||
      hitType === 'outline' ||
      hitType === 'notes' ||
      hitType === 'characters' ||
      hitType === 'places' ||
      hitType === 'tags' ||
      hitType === 'lines' ||
      hitType === 'beats'
    ) {
      jumpToHit(cards, hitType, hit)(dispatch, getState)
    }
  })(dispatch)
}

/**
 * @return {{ type: 'START_DELETING_CARD_FROM_CARD_DIALOG' }}
 */
export const startDeletingCardFromCardDialog = () => {
  return { type: START_DELETING_CARD_FROM_CARD_DIALOG }
}

/**
 * @return {{ type: 'STOP_DELETING_CARD_FROM_CARD_DIALOG' }}
 */
export const stopDeletingCardFromCardDialog = () => {
  return { type: STOP_DELETING_CARD_FROM_CARD_DIALOG }
}

/**
 * @return {{ type: 'SHOW_CARD_DIALOG_COLOR_PICKER' }}
 */
export const showCardDialogColorPicker = () => {
  return { type: SHOW_CARD_DIALOG_COLOR_PICKER }
}

/**
 * @return {{ type: 'HIDE_CARD_DIALOG_COLOR_PICKER' }}
 */
export const hideCardDialogColorPicker = () => {
  return { type: HIDE_CARD_DIALOG_COLOR_PICKER }
}

/**
 * @return {{ type: 'SHOW_CARD_DIALOG_TEMPLATE_PICKER' }}
 */
export const showCardDialogTemplatePicker = () => {
  return { type: SHOW_CARD_DIALOG_TEMPLATE_PICKER }
}

/**
 * @return {{ type: 'HIDE_CARD_DIALOG_TEMPLATE_PICKER' }}
 */
export const hideCardDialogTemplatePicker = () => {
  return { type: HIDE_CARD_DIALOG_TEMPLATE_PICKER }
}

/**
 * @param {String} id
 * @return {{ type: 'START_REMOVING_TEMPLATE_FROM_CARD_DIALOG', id: String }}
 */
export const startRemovingTemplateFromCardDialog = (id) => {
  return { type: START_REMOVING_TEMPLATE_FROM_CARD_DIALOG, id }
}

/**
 * @return {{ type: 'STOP_REMOVING_TEMPLATE_FROM_CARD_DIALOG' }}
 */
export const stopRemovingTemplateFromCardDialog = () => {
  return { type: STOP_REMOVING_TEMPLATE_FROM_CARD_DIALOG }
}

/**
 * @param {number} tabIndex
 * @return {{ type: 'SET_ACTIVE_TAB_ON_CARD_DIALOG', tabIndex: number }}
 */
export const setActiveTabOnCardDialog = (tabIndex) => {
  return { type: SET_ACTIVE_TAB_ON_CARD_DIALOG, tabIndex }
}

/**
 * @return {{ type: 'SHOW_PLACE_ATTRIBUTE_DIALOG' }}
 */
export function showPlaceAttributeDialog() {
  return { type: SHOW_PLACE_ATTRIBUTE_DIALOG }
}

/**
 * @return {{ type: 'HIDE_PLACE_ATTRIBUTE_DIALOG' }}
 */
export function hidePlaceAttributeDialog() {
  return { type: HIDE_PLACE_ATTRIBUTE_DIALOG }
}

/**
 * @return {{ type: 'START_EDITING_SELECTED_PLACE' }}
 */
export function startEditingSelectedPlace() {
  return { type: START_EDITING_SELECTED_PLACE }
}

/**
 * @return {{ type: 'FINISH_EDITING_SELECTED_PLACE' }}
 */
export function finishEditingSelectedPlace() {
  return { type: FINISH_EDITING_SELECTED_PLACE }
}

/**
 * @return {{ type: 'SHOW_PLACE_CATETORIES_MODAL' }}
 */
export function showPlaceCategoryModal() {
  return { type: SHOW_PLACE_CATETORIES_MODAL }
}

/**
 * @return {{ type: 'HIDE_PLACE_CATETORIES_MODAL' }}
 */
export function hidePlaceCategoryModal() {
  return { type: HIDE_PLACE_CATETORIES_MODAL }
}

/**
 * @return {{ type: 'SHOW_PLACE_FILTER_LIST' }}
 */
export function showPlaceFilterList() {
  return { type: SHOW_PLACE_FILTER_LIST }
}

/**
 * @return {{ type: 'HIDE_PLACE_FILTER_LIST' }}
 */
export function hidePlaceFilterList() {
  return { type: HIDE_PLACE_FILTER_LIST }
}

/**
 * @return {{ type: 'SHOW_PLACE_SORT' }}
 */
export function showPlaceSort() {
  return { type: SHOW_PLACE_SORT }
}

/**
 * @return {{ type: 'HIDE_PLACE_SORT' }}
 */
export function hidePlaceSort() {
  return { type: HIDE_PLACE_SORT }
}

/**
 * @return {{ type: 'START_EDITING_SELECTED_NOTE' }}
 */
export function startEditingSelectedNote() {
  return { type: START_EDITING_SELECTED_NOTE }
}

/**
 * @return {{ type: 'FINISH_EDITING_SELECTED_NOTE' }}
 */
export function finishEditingSelectedNote() {
  return { type: FINISH_EDITING_SELECTED_NOTE }
}

/**
 * @return {{ type: 'SHOW_NOTES_CATEGORY_DIALOG' }}
 */
export function showNotesCategoryDialog() {
  return { type: SHOW_NOTES_CATEGORY_DIALOG }
}

/**
 * @return {{ type: 'HIDE_NOTES_CATEGORY_DIALOG' }}
 */
export function hideNotesCategoryDialog() {
  return { type: HIDE_NOTES_CATEGORY_DIALOG }
}

/**
 * @return {{ type: 'SHOW_NOTES_ATTRIBUTES_DIALOG' }}
 */
export function showNotesAttributesDialog() {
  return { type: SHOW_NOTES_ATTRIBUTES_DIALOG }
}

/**
 * @return {{ type: 'HIDE_NOTES_ATTRIBUTES_DIALOG' }}
 */
export function hideNotesAttributesDialog() {
  return { type: HIDE_NOTES_ATTRIBUTES_DIALOG }
}

/**
 * @return {{ type: 'SHOW_NOTES_FILTER_LIST' }}
 */
export function showNotesFilterList() {
  return { type: SHOW_NOTES_FILTER_LIST }
}

/**
 * @return {{ type: 'HIDE_NOTES_FILTER_LIST' }}
 */
export function hideNotesFilterList() {
  return { type: HIDE_NOTES_FILTER_LIST }
}

/**
 * @return {{ type: 'SHOW_NOTES_SORT' }}
 */
export function showNotesSort() {
  return { type: SHOW_NOTES_SORT }
}

/**
 * @return {{ type: 'HIDE_NOTES_SORT' }}
 */
export function hideNotesSort() {
  return { type: HIDE_NOTES_SORT }
}

/**
 * @return {{ type: 'SHOW_CHARACTERS_ATTRIBUTES_DIALOG' }}
 */
export function showCharactersAttributesDialog() {
  return { type: SHOW_CHARACTERS_ATTRIBUTES_DIALOG }
}

/**
 * @return {{ type: 'HIDE_CHARACTERS_ATTRIBUTES_DIALOG' }}
 */
export function hideCharactersAttributesDialog() {
  return { type: HIDE_CHARACTERS_ATTRIBUTES_DIALOG }
}

/**
 * @return {{ type: 'SHOW_CHARACTERS_CATEGORIES_DIALOG' }}
 */
export function showCharactersCategoryDialog() {
  return { type: SHOW_CHARACTERS_CATEGORIES_DIALOG }
}

/**
 * @return {{ type: 'HIDE_CHARACTERS_CATEGORIES_DIALOG' }}
 */
export function hideCharactersCategoryDialog() {
  return { type: HIDE_CHARACTERS_CATEGORIES_DIALOG }
}

/**
 * @return {{ type: 'START_EDITING_SELECTED_CHARACTER' }}
 */
export function startEditingSelectedCharacter() {
  return { type: START_EDITING_SELECTED_CHARACTER }
}

/**
 * @return {{ type: 'FINISH_EDITING_SELECTED_CHARACTER' }}
 */
export function finishEditingSelectedCharacter() {
  return { type: FINISH_EDITING_SELECTED_CHARACTER }
}

/**
 * @return {{ type: 'SHOW_CHARACTERS_TEMPLATE_PICKER' }}
 */
export function showCharactersTemplatePicker() {
  return { type: SHOW_CHARACTERS_TEMPLATE_PICKER }
}

/**
 * @return {{ type: 'HIDE_CHARACTERS_TEMPLATE_PICKER' }}
 */
export function hideCharactersTemplatePicker() {
  return { type: HIDE_CHARACTERS_TEMPLATE_PICKER }
}

/**
 * @return {{ type: 'START_CREATING_CHARACTER' }}
 */
export function startCreatingCharacter() {
  return { type: START_CREATING_CHARACTER }
}

/**
 * @return {{ type: 'FINISH_CREATING_CHARACTER' }}
 */
export function finishCreatingCharacter() {
  return { type: FINISH_CREATING_CHARACTER }
}

/**
 * @param {CharacterTemplate | CharacterCustomTemplate | Null} templateData
 * @return {{ type: 'SET_CHARACTER_TEMPLATE_DATA', templateData: CharacterTemplate | CharacterCustomTemplate | Null }}
 */
export function setCharacterTemplateData(templateData) {
  return { type: SET_CHARACTER_TEMPLATE_DATA, templateData }
}

/**
 * @return {{ type: 'SHOW_CHARACTER_FILTER' }}
 */
export function showCharacterFilter() {
  return { type: SHOW_CHARACTER_FILTER }
}

/**
 * @return {{ type: 'HIDE_CHARACTER_FILTER' }}
 */
export function hideCharacterFilter() {
  return { type: HIDE_CHARACTER_FILTER }
}

/**
 * @return {{ type: 'SHOW_CHARACTER_SORT' }}
 */
export function showCharacterSort() {
  return { type: SHOW_CHARACTER_SORT }
}

/**
 * @return {{ type: 'HIDE_CHARACTER_SORT' }}
 */
export function hideCharacterSort() {
  return { type: HIDE_CHARACTER_SORT }
}

/**
 * @return {{ type: 'SHOW_CHARACTER_DETAILS' }}
 */
export function showCharacterDetails() {
  return { type: SHOW_CHARACTER_DETAILS }
}

/**
 * @return {{ type: 'HIDE_CHARACTER_DETAILS' }}
 */
export function hideCharacterDetails() {
  return { type: HIDE_CHARACTER_DETAILS }
}

/**
 * @return {{ type: 'START_DELETING_CHARACTER' }}
 */
export const startDeletingCharacter = () => {
  return { type: START_DELETING_CHARACTER }
}

/**
 * @return {{ type: 'FINISH_DELETING_CHARACTER' }}
 */
export const finishDeletingCharacter = () => {
  return { type: FINISH_DELETING_CHARACTER }
}

/**
 * @return {{ type: 'START_REMOVING_TEMPLATE_FROM_CHARACTER' }}
 */
export const startRemovingTemplateFromCharacter = () => {
  return { type: START_REMOVING_TEMPLATE_FROM_CHARACTER }
}

/**
 * @return {{ type: 'FINISH_REMOVING_TEMPLATE_FROM_CHARACTER' }}
 */
export const finishRemovingTemplateFromCharacter = () => {
  return { type: FINISH_REMOVING_TEMPLATE_FROM_CHARACTER }
}

/**
 * @param {String | Null} template
 * @return {{ type: 'SET_TEMPLATE_TO_REMOVE_FROM_CHARACTER', template: String | Null }}
 */
export const setTemplateToRemoveFromCharacter = (template) => {
  return { type: SET_TEMPLATE_TO_REMOVE_FROM_CHARACTER, template }
}

/**
 * @param {number} tab
 * @return {{ type: 'SET_ACTIVE_CHARACTER_TAB', tab: number }}
 */
export const setActiveCharacterTab = (tab) => {
  return { type: SET_ACTIVE_CHARACTER_TAB, tab }
}

/**
 * @return {{ type: 'SHOW_CHARACTER_EDITOR_TEMPLATE_PICKER' }}
 */
export const showCharacterEditorTemplatePicker = () => {
  return { type: SHOW_CHARACTER_EDITOR_TEMPLATE_PICKER }
}

/**
 * @return {{ type: 'HIDE_CHARACTER_EDITOR_TEMPLATE_PICKER' }}
 */
export const hideCharacterEditorTemplatePicker = () => {
  return { type: HIDE_CHARACTER_EDITOR_TEMPLATE_PICKER }
}

/**
 * @param {number} id
 * @return {{ type: 'START_EDITING_OUTLINE_CARD', id: number }}
 */
export const startEditingOutlineCard = (id) => {
  return { type: START_EDITING_OUTLINE_CARD, id }
}

/**
 * @return {{ type: 'FINISH_EDITING_OUTLINE_CARD' }}
 */
export const finishEditingOutlineCard = () => {
  return { type: FINISH_EDITING_OUTLINE_CARD }
}

/**
 * @param {number | Null} id
 * @return {{ type: 'SET_EDITING_BEAT_ID', id: number | Null }}
 */
export function setEditingBeatTitleId(id) {
  return { type: SET_EDITING_BEAT_ID, id }
}

/**
 * @return {{ type: 'OPEN_RESTRUCTURE_TIMELINE_MODAL' }}
 */
export function openRestructureTimelineModal() {
  return { type: OPEN_RESTRUCTURE_TIMELINE_MODAL }
}

/**
 * @return {{ type: 'CLOSE_RESTRUCTURE_TIMELINE_MODAL' }}
 */
export function closeRestructureTimelineModal() {
  return { type: CLOSE_RESTRUCTURE_TIMELINE_MODAL }
}

/**
 * @return {{ type: 'EDIT_SELECTED_TAG' }}
 */
export function editSelectedTag() {
  return { type: EDIT_SELECTED_TAG }
}

/**
 * @return {{ type: 'FINISH_EDITING_SELECTED_TAG' }}
 */
export function finishEditingSelectedTag() {
  return { type: FINISH_EDITING_SELECTED_TAG }
}

/**
 * @return {{ type: 'TOGGLE_REPLACE_SEARCH' }}
 */
export function toggleReplaceSearch() {
  return { type: TOGGLE_REPLACE_SEARCH }
}

/**
 * @param {String} newReplacementText
 * @return {{ type: 'SET_REPLACEMENT_TEXT', newReplacementText: String }}
 */
export function setReplacementText(newReplacementText) {
  return { type: SET_REPLACEMENT_TEXT, newReplacementText }
}

/**
 * @param {SearchHit} hit
 * @return {{ type: 'TOGGLE_HIT_MARKED_FOR_REPLACEMENT', hit: SearchHit }}
 */
export const _toggleHitMarkedForReplacement = (hit) => {
  return {
    type: TOGGLE_HIT_MARKED_FOR_REPLACEMENT,
    hit,
  }
}

/**
 * @param {SearchHit} hit
 * @return {function(Dispatch, GetState): Void}
 */
export function toggleHitMarkedForReplacement(hit) {
  return function (dispatch, getState) {
    const state = getState()
    const currentHits = flatSearchHitsSelector(state)
    const foundInList = currentHits.find((currentHit) => {
      return isEqual(currentHit, hit)
    })
    if (foundInList) {
      dispatch(_toggleHitMarkedForReplacement(hit))
    }
  }
}

/**
 * @return {{ type: 'START_SEARCHING' }}
 */
export const _startSearching = () => {
  return {
    type: START_SEARCHING,
  }
}

/**
 * @param {Array<SearchHit>} hitsMarkedForReplacement
 * @param {String} replacementText
 * @return {{ type: 'REPLACE_MARKED_HITS', hitsMarkedForReplacement: Array<SearchHit>, replacementText: String }}
 */
export const _replaceMarkedHits = (hitsMarkedForReplacement, replacementText) => {
  return {
    type: REPLACE_MARKED_HITS,
    hitsMarkedForReplacement,
    replacementText,
  }
}

/**
 * @return {{ type: 'START_VIEWING' }}
 */
export const _startViewing = () => {
  return {
    type: START_VIEWING,
  }
}

/**
 * @return {function(Dispatch, GetState): Void}
 */
export function replaceMarkedHits() {
  return function (dispatch, getState) {
    const state = getState()
    const hitsMarkedForReplacement = hitsMarkedForReplacementSelector(state)
    if (hitsMarkedForReplacement.length > 0) {
      // N.B.  Don't batch these actions because components need to
      // know that they ought not to trigger any effects while we're
      // still searching.
      dispatch(_startSearching())
      const replacementText = searchReplacementTextSelector(state)
      dispatch(_replaceMarkedHits(hitsMarkedForReplacement, replacementText))
      dispatch(_startViewing())
    }
    dispatch(closeSearch())
  }
}

/**
 * @param {boolean} replaceWord
 * @return {{ type: 'SET_REPLACE_WORD', replaceWord: boolean }}
 */
export function setReplaceWord(replaceWord) {
  return {
    type: SET_REPLACE_WORD,
    replaceWord,
  }
}

/**
 * @return {{ type: 'START_SCANNING_SEARCH' }}
 */
export function startScanningSearch() {
  return { type: START_SCANNING_SEARCH }
}

/**
 * @param {number} id
 * @return {{ type: 'START_EDITING_BEAT_HEADING_TITLE', id: number }}
 */
export function startEditingBeatHeadingTitle(id) {
  return { type: START_EDITING_BEAT_HEADING_TITLE, id }
}

/**
 * @return {{ type: 'STOP_EDITING_BEAT_HEADING_TITLE' }}
 */
export function stopEditingBeatHeadingTitle() {
  return { type: STOP_EDITING_BEAT_HEADING_TITLE }
}

/**
 * @param {number} id
 * @return {{ type: 'START_EDITING_PLOTLINE_HEADING_TITLE', id: number }}
 */
export function startEditingPlotlineHeadingTitle(id) {
  return { type: START_EDITING_PLOTLINE_HEADING_TITLE, id }
}

/**
 * @return {{ type: 'STOP_EDITING_PLOTLINE_HEADING_TITLE' }}
 */
export function stopEditingPlotlineHeadingTitle() {
  return { type: STOP_EDITING_PLOTLINE_HEADING_TITLE }
}

/**
 * @param {DashboardModalView} view
 * @return {{ type: 'SET_DASHBOARD_MODAL_VIEW', view: DashboardModalView }}
 */
export function setDashboardModalView(view) {
  return { type: SET_DASHBOARD_MODAL_VIEW, view }
}

/**
 * @param {'characters' | 'notes' | 'tags' | 'places' | 'outline'} section
 * @param {number} id
 * @param {boolean} checked
 * @return {{ type: 'TOGGLE_ID_MARKED_TO_IMPORT', section: 'characters' | 'notes' | 'tags' | 'places' | 'outline', id: number, checked: boolean }}
 */
export function toggleIdMarkedToImport(section, id, checked) {
  return {
    type: TOGGLE_ID_MARKED_TO_IMPORT,
    section,
    id,
    checked,
  }
}

/**
 * @param {keyof ImportModalUiData} section
 * @param {boolean} checked
 * @return {{ type: 'TOGGLE_ALL_SECTION_MARKED_TO_IMPORT', section: keyof ImportModalUiData, checked: boolean }}
 */
export function toggleAllSectionMarkedToImport(section, checked) {
  return {
    type: TOGGLE_ALL_SECTION_MARKED_TO_IMPORT,
    section,
    checked,
  }
}

/**
 * @param {number | 'series'} bookId
 * @param {boolean} checked
 * @return {{ type: 'TOGGLE_BOOK_TO_IMPORT', bookId: number | 'series', checked: boolean }}
 */
export function toggleBookToImport(bookId, checked) {
  return {
    type: TOGGLE_BOOK_TO_IMPORT,
    checked,
    bookId,
  }
}

/**
 * @param {'characters' | 'notes' | 'tags' | 'places' | 'outline'} section
 * @param {boolean} checked
 * @return {{ type: 'TOGGLE_CUSTOM_ATTRIBUTE_TO_IMPORT', section: 'characters' | 'notes' | 'tags' | 'places' | 'outline', checked: boolean }}
 */
export function toggleCustomAttributeToImport(section, checked) {
  return {
    type: TOGGLE_CUSTOM_ATTRIBUTE_TO_IMPORT,
    checked,
    section,
  }
}

/**
 * @return {{ type: 'CLOSE_IMPORT_PLOTTR_MODAL' }}
 */
export function closeImportPltrModal() {
  return {
    type: CLOSE_IMPORT_PLOTTR_MODAL,
  }
}

/**
 * @param {Books} books
 * @param {PlottrFileBeats} beats
 * @param {Array<Card>} cards
 * @param {HierarchyLevelsPlottrFile} hierarchyLevels
 * @param {Array<Line>} lines
 * @param {LegacyCustomAttributes} customAttributes
 * @param {Omit<LegacyCustomAttributes, 'characters'>} existingCustomAttributes
 * @param {Array<Note>}  notes
 * @param {Array<Character>} characters
 * @param {Array<Place>} places
 * @param {Array<Tag>} tags
 * @param {PlottrFileImages} images
 * @return {{ type: 'SHOW_IMPORT_DATA_PICKER', books: Books, beats: PlottrFileBeats, cards: Array<Card>, hierarchyLevels: HierarchyLevelsPlottrFile, lines: Array<Line>, customAttributes: LegacyCustomAttributes, existingCustomAttributes: Omit<LegacyCustomAttributes, 'characters'>, notes: Array<Note>, characters: Array<Character>, places: Array<Place>, tags: Array<Tag>, images: PlottrFileImages, fileType: 'pltr' | null }}
 */
export const _showImportDataPicker = (
  books,
  beats,
  cards,
  hierarchyLevels,
  lines,
  customAttributes,
  existingCustomAttributes,
  notes,
  characters,
  places,
  tags,
  images
) => {
  return {
    type: SHOW_IMPORT_DATA_PICKER,
    books,
    beats,
    cards,
    hierarchyLevels,
    lines,
    customAttributes,
    existingCustomAttributes,
    notes,
    characters,
    places,
    tags,
    images,
    fileType: 'pltr',
  }
}

/**
 * @param {PlottrFile} pltrData
 * @param {SystemState} system
 * @return {function(Dispatch, GetState): Void}
 */
export const showImportDataPicker = (pltrData, system) => (dispatch, getState) => {
  const state = {
    user: pltrData,
    system,
  }
  const reduxState = getState()
  const books = allBooksSelector(state)
  const allBeats = allBeatsSelector(state)
  const allCards = allCardsSelector(state)
  const hierarchyLevels = allHierarchyLevelsSelector(state)
  const lines = allLinesSelector(state)
  const cardAttrs = cardsCustomAttributesSelector(state)
  const characterAttrs = characterCustomAttributesSelector(state)
  const placeAttrs = placeCustomAttributesSelector(state)
  const notesAttrs = noteCustomAttributesSelector(state)
  const notes = allNotesSelector(state)
  const characters = allCharactersSelector(state)
  const places = allPlacesSelector(state)
  const tags = allTagsSelector(state)
  const images = imagesSelector(state)
  const existingCardAttrs = cardsCustomAttributesSelector(reduxState)
  const existingPlaceAttrs = placeCustomAttributesSelector(reduxState)
  const existingNoteAttrs = noteCustomAttributesSelector(reduxState)

  const customAttributes = {
    scenes: cardAttrs,
    characters: characterAttrs,
    places: placeAttrs,
    notes: notesAttrs,
    lines: [],
  }

  const existingCustomAttributes = {
    scenes: existingCardAttrs,
    places: existingPlaceAttrs,
    notes: existingNoteAttrs,
    lines: [],
  }

  dispatch(
    _showImportDataPicker(
      books,
      allBeats,
      allCards,
      hierarchyLevels,
      lines,
      customAttributes,
      existingCustomAttributes,
      notes,
      characters,
      places,
      tags,
      images
    )
  )
}

/**
 * @return {{ type: 'SHOW_PRO_ACCOUNT_RECENT_FILES' }}
 */
export const showProAccountRecentFiles = () => {
  return {
    type: SHOW_PRO_ACCOUNT_RECENT_FILES,
  }
}

/**
 * @return {{ type: 'CLOSE_CONFLICT_RESOLUTION_MODAL' }}
 */
export const closeConflictResolutionModal = () => {
  return {
    type: CLOSE_CONFLICT_RESOLUTION_MODAL,
  }
}

/**
 * @param {OutlineTabView} view
 * @return {{ type: 'SET_OUTLINE_VIEW', view: OutlineTabView }}
 */
export const setOutlineView = (view) => {
  return {
    type: SET_OUTLINE_VIEW,
    view,
  }
}

/**
 * @return {{ type: 'SHOW_FULLTEXT_PAGE_LAYOUT_CONFIG' }}
 */
export const showFulltextLayoutConfig = () => {
  return {
    type: SHOW_FULLTEXT_PAGE_LAYOUT_CONFIG,
  }
}

/**
 * @return {{ type: 'HIDE_FULLTEXT_PAGE_LAYOUT_CONFIG' }}
 */
export const closeFulltextLayoutConfig = () => {
  return {
    type: HIDE_FULLTEXT_PAGE_LAYOUT_CONFIG,
  }
}

/**
 * @param {boolean} show
 * @return {{ type: 'SHOW_FULLTEXT_CHAPTER_TITLE', show: boolean }}
 */
export const showFulltextCardTitle = (show) => {
  return {
    type: SHOW_FULLTEXT_CHAPTER_TITLE,
    show,
  }
}

/**
 * @param {boolean} show
 * @return {{ type: 'SHOW_FULLTEXT_BEAT_TITLE', show: boolean }}
 */
export const showFulltextBeatTitle = (show) => {
  return {
    type: SHOW_FULLTEXT_BEAT_TITLE,
    show,
  }
}

/**
 * @param {number} light
 * @return {{ type: 'SET_FULLTEXT_PLOTLINE_COLOR', light: number }}
 */
export const setFulltextLighterPlotlinePageColor = (light) => {
  return {
    type: SET_FULLTEXT_PLOTLINE_COLOR,
    light,
  }
}

/**
 * @return {{ type: 'ADD_OUTLINE_FULLTEXT_ZOOM' }}
 */
export const addOutlineFulltextZoom = () => {
  return { type: ADD_OUTLINE_FULLTEXT_ZOOM }
}

/**
 * @return {{ type: 'REDUCE_OUTLINE_FULLTEXT_ZOOM' }}
 */
export const reduceOutlineFulltextZoom = () => {
  return { type: REDUCE_OUTLINE_FULLTEXT_ZOOM }
}

/**
 * @param {String} beatTitle
 * @param {String} lineTitle
 * @param {String} cardTitle
 * @param {number} cardId
 * @return {{ type: 'SHOW_FULLTEXT_CARD_HOVER_DETAILS', beatTitle: String, lineTitle: String, cardTitle: String, cardId: number }}
 */
export const showFulltextCardHoverDetails = (beatTitle, lineTitle, cardTitle, cardId) => ({
  type: SHOW_FULLTEXT_CARD_HOVER_DETAILS,
  beatTitle,
  lineTitle,
  cardTitle,
  cardId,
})

/**
 * @return {{ type: 'HIDE_FULLTEXT_CARD_HOVER_DETAILS' }}
 */
export const hideFulltextCardHoverDetails = () => {
  return {
    type: HIDE_FULLTEXT_CARD_HOVER_DETAILS,
  }
}

/**
 * @param {boolean} show
 * @return {{ type: 'TOGGLE_FULLTEXT_SHOW_BEAT_GAPS', show: boolean }}
 */
export const toggleFulltextShowBeatGaps = (show) => {
  return {
    type: TOGGLE_FULLTEXT_SHOW_BEAT_GAPS,
    show,
  }
}

/**
 * @param {TextAlignment} alignment
 * @return {{ type: 'SET_FULLTEXT_BEAT_TITLE_ALIGNMENT', alignment: TextAlignment }}
 */
export const setFulltextBeatTitleAlignment = (alignment) => {
  return {
    type: SET_FULLTEXT_BEAT_TITLE_ALIGNMENT,
    alignment,
  }
}

/**
 * @param {TextAlignment} alignment
 * @return {{ type: 'SET_FULLTEXT_CARD_TITLE_ALIGNMENT', alignment: TextAlignment }}
 */
export const setFulltextCardTitleAlignment = (alignment) => {
  return {
    type: SET_FULLTEXT_CARD_TITLE_ALIGNMENT,
    alignment,
  }
}

/**
 * @param {boolean} pinned
 * @return {{ type: 'SET_OUTLINE_DETAILS_PINNED', pinned: boolean }}
 */
export const setOutlineDetailsPinned = (pinned) => {
  return {
    type: SET_OUTLINE_DETAILS_PINNED,
    pinned,
  }
}

/**
 * @param {CardColorSource | Null} source
 * @return {{ type: 'TOGGLE_OUTLINE_CARD_COLOR_SOURCE', source: CardColorSource | Null }}
 */
export const togglePlotlineCardColorSource = (source) => {
  return {
    type: TOGGLE_OUTLINE_CARD_COLOR_SOURCE,
    source,
  }
}

/**
 * @return {{ type: 'TOGGLE_SMALL_TIMELINE_CARD_COLOR_SOURCE' }}
 */
export const toggleSmallTimelinePlotlineCardColorSource = () => {
  return {
    type: TOGGLE_SMALL_TIMELINE_CARD_COLOR_SOURCE,
  }
}

/**
 * @return {{ type: 'DESELECT_CHARACTER_FOR_CHANGING_IMAGE' }}
 */
export const deselectCharacterForChangingImage = () => {
  return {
    type: DESELECT_CHARACTER_FOR_CHANGING_IMAGE,
  }
}

/**
 * @param {number} characterId
 * @return {{ type: 'SELECT_CHARACTER_FOR_CHANGING_IMAGE', characterId: number }}
 */
export const selectCharacterForChangingImage = (characterId) => {
  return {
    type: SELECT_CHARACTER_FOR_CHANGING_IMAGE,
    characterId,
  }
}

/**
 * @return {{ type: 'OPEN_RELATIONSHIP_EDITOR' }}
 */
export const openRelationshipEditor = () => {
  return {
    type: OPEN_RELATIONSHIP_EDITOR,
  }
}

/**
 * @return {{ type: 'CLOSE_RELATIONSHIP_EDITOR' }}
 */
export const closeRelationshipEditor = () => {
  return {
    type: CLOSE_RELATIONSHIP_EDITOR,
  }
}

/**
 * @param {String} relationshipType
 * @return {{ type: 'SELECT_RELATIONSHIP_TYPE', relationshipType: String }}
 */
export const selectRelationshipType = (relationshipType) => {
  return {
    type: SELECT_RELATIONSHIP_TYPE,
    relationshipType,
  }
}

/**
 * @return {{ type: 'SHOW_RELATIONSHIP_EDITOR_COLOUR_PICKER' }}
 */
export const showRelationshipEditorColourPicker = () => {
  return {
    type: SHOW_RELATIONSHIP_EDITOR_COLOUR_PICKER,
  }
}

/**
 * @return {{ type: 'HIDE_RELATIONSHIP_EDITOR_COLOUR_PICKER' }}
 */
export const hideRelationshipEditorColourPicker = () => {
  return {
    type: HIDE_RELATIONSHIP_EDITOR_COLOUR_PICKER,
  }
}

/**
 * @param {number} id
 * @return {{ type: 'START_EDITING_FAMILY_TREE_NAME_BY_ID', id: number }}
 */
export const startEditingFamilyTreeNameById = (id) => {
  return {
    type: START_EDITING_FAMILY_TREE_NAME_BY_ID,
    id,
  }
}

/**
 * @param {number} id
 * @return {{ type: 'SELECT_FAMILY_TREE', id: number }}
 */
export const selectFamilyTree = (id) => {
  return {
    type: SELECT_FAMILY_TREE,
    id,
  }
}

/**
 * @return {{ type: 'FINISH_EDITING_FAMILY_TREE_NAME' }}
 */
export const finishEditingFamilyTreeName = () => {
  return {
    type: FINISH_EDITING_FAMILY_TREE_NAME,
  }
}

/**
 * @param {SearchDialogActiveTab} activeTab
 * @return {{ type: 'SET_SEARCH_MODAL_ACTIVE_TAB', activeTab: SearchDialogActiveTab }}
 */
export const _setSearchModalActiveTab = (activeTab) => {
  return {
    type: SET_SEARCH_MODAL_ACTIVE_TAB,
    activeTab,
  }
}

/**
 * @return {{ type: 'OPEN_SEARCH' }}
 */
export const _openSearch = () => {
  return {
    type: OPEN_SEARCH,
  }
}

/**
 * @return {{ type: 'OPEN_REPLACE' }}
 */
export const _openReplace = () => {
  return {
    type: OPEN_REPLACE,
  }
}

/**
 * @param {SearchDialogActiveTab} activeTab
 * @return {function(Dispatch, GetState): Void}
 */
export const setSearchModalActiveTab = (activeTab) => (dispatch) => {
  dispatch(_setSearchModalActiveTab(activeTab))

  if (activeTab === 'search') {
    dispatch(_openSearch())
  } else if (activeTab === 'replace') {
    dispatch(_openReplace())
  }
}

/**
 * @return {{ type: 'OPEN_SEARCH_MODAL_TO_BOOKMARKS' }}
 */
export const openSearchModalToBookmarks = () => {
  return {
    type: OPEN_SEARCH_MODAL_TO_BOOKMARKS,
  }
}

/**
 * Set the multiplier to scale the X and Y dimensions of the drawn
 * family tree.
 *
 * @param {number} familyTreeId
 * @param {number} scale
 * @return {{ type: 'SET_FAMILY_TREE_SCALE', id: number, scale: number }}
 */
export const setFamilyTreeScale = (familyTreeId, scale) => {
  return {
    type: SET_FAMILY_TREE_SCALE,
    id: familyTreeId,
    scale,
  }
}

/**
 * Set the x and y offset that the user panned to for the family tree
 * with the provided id.
 * @param {number} familyTreeId
 * @param {number} x
 * @param {number} y
 * @return {{ type: 'SET_FAMILY_TREE_POSITION', id: number, x: number, y: number }}
 */
export function setFamilyTreePosition(familyTreeId, x, y) {
  return {
    type: SET_FAMILY_TREE_POSITION,
    id: familyTreeId,
    x,
    y,
  }
}

/**
 * @param {DocumentationType} documentationType
 * @return {{ type: 'OPEN_DOCUMENTATION_MODAL', documentationType: DocumentationType }}
 */
export const openDocumentationModal = (documentationType) => {
  return {
    type: OPEN_DOCUMENTATION_MODAL,
    documentationType,
  }
}

/**
 * @return {{ type: 'CLOSE_DOCUMENTATION_MODAL' }}
 */
export const closeDocumentationModal = () => {
  return {
    type: CLOSE_DOCUMENTATION_MODAL,
  }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @return {{ type: 'SHOW_QUICK_EDIT_MODAL', kind: PreviewPanelEntityKind, id: number }}
 */
export const showQuickEditModal = (kind, id) => {
  return {
    type: SHOW_QUICK_EDIT_MODAL,
    kind,
    id,
  }
}

/**
 * @return {{ type: 'CLOSE_QUICK_EDIT_MODAL' }}
 */
export const closeQuickEditModal = () => {
  return {
    type: CLOSE_QUICK_EDIT_MODAL,
  }
}

// Preview Panels

/**
 * @return {{ type: 'SHOW_PREVIEW_PANELS' }}
 */
export const showPreviewPanels = () => {
  return {
    type: SHOW_PREVIEW_PANELS,
  }
}

/**
 * @return {{ type: 'HIDE_PREVIEW_PANELS' }}
 */
export const hidePreviewPanels = () => {
  return {
    type: HIDE_PREVIEW_PANELS,
  }
}

/**
 * @param {number} id
 * @return {{ type: 'PIN_CARD_TO_PIN_BOARD', id: number }}
 */
export function pinCard(id) {
  return { type: PIN_CARD_TO_PIN_BOARD, id }
}

/**
 * @param {number} id
 * @return {{ type: 'UNPIN_CARD_FROM_PIN_BOARD', id: number }}
 */
export function unpinCard(id) {
  return { type: UNPIN_CARD_FROM_PIN_BOARD, id }
}

/**
 * @param {number} id
 * @return {{ type: 'PIN_NOTE_TO_PINBOARD', id: number }}
 */
export function pinNote(id) {
  return { type: PIN_NOTE_TO_PINBOARD, id }
}

/**
 * @param {number} id
 * @return {{ type: 'UNPIN_NOTE_FROM_PINBOARD', id: number }}
 */
export function unpinNote(id) {
  return { type: UNPIN_NOTE_FROM_PINBOARD, id }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @param {number} top
 * @param {number} left
 * @return {{ type: 'FLOAT_PREVIEW_PANEL', id: number, kind: PreviewPanelEntityKind, top: number, left: number }}
 */
export function floatPreviewPanel(kind, id, top, left) {
  return {
    type: FLOAT_PREVIEW_PANEL,
    kind,
    id,
    top,
    left,
  }
}

/**
 * @param {number} id
 * @return {{ type: 'PIN_CHARACTER_TO_PIN_BOARD', id: number }}
 */
export function pinCharacter(id) {
  return { type: PIN_CHARACTER_TO_PIN_BOARD, id }
}

/**
 * @param {number} id
 * @return {{ type: 'UNPIN_CHARACTER_FROM_PIN_BOARD', id: number }}
 */
export function unpinCharacter(id) {
  return { type: UNPIN_CHARACTER_FROM_PIN_BOARD, id }
}

/**
 * @param {number} id
 * @return {{ type: 'PIN_PLACE_TO_PIN_BOARD', id: number }}
 */
export function pinPlace(id) {
  return { type: PIN_PLACE_TO_PIN_BOARD, id }
}

/**
 * @param {number} id
 * @return {{ type: 'UNPIN_PLACE_FROM_PIN_BOARD', id: number }}
 */
export function unpinPlace(id) {
  return { type: UNPIN_PLACE_FROM_PIN_BOARD, id }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @return {{ type: 'TOGGLE_EXPAND_PREVIEW_PANEL', kind: PreviewPanelEntityKind, id: number }}
 */
export const toggleExpandPreviewPanel = (kind, id) => {
  return {
    type: TOGGLE_EXPAND_PREVIEW_PANEL,
    kind,
    id,
  }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @param {boolean} minimized
 * @return {{ type: 'TOGGLE_MINIMIZE_PREVIEW_PANEL', kind: PreviewPanelEntityKind, id: number, minimized: boolean }}
 */
export const toggleMinimizePreviewPanel = (kind, id, minimized) => {
  return {
    type: TOGGLE_MINIMIZE_PREVIEW_PANEL,
    kind,
    id,
    minimized,
  }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @param {number} top
 * @param {number} left
 * @return {{ type: 'SAVE_PINNED_PREVIEW_COORDS', kind: PreviewPanelEntityKind, id: number, top: number, left: number }}
 */
export const savePreviewPanelCoords = (kind, id, top, left) => {
  return {
    type: SAVE_PINNED_PREVIEW_COORDS,
    id,
    kind,
    top,
    left,
  }
}

/**
 * @return {{ type: 'UNPIN_ALL_PREVIEW_PANELS' }}
 */
export const unpinAllPreviewPanels = () => {
  return {
    type: UNPIN_ALL_PREVIEW_PANELS,
  }
}

/**
 * @param {boolean} show
 * @return {{ type: 'SHOW_PREVIEW_PANELS_CONFIRM_MODAL', show: boolean }}
 */
export const openPreviewPanelConfirmModal = (show) => {
  return {
    type: SHOW_PREVIEW_PANELS_CONFIRM_MODAL,
    show,
  }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @param {boolean} shrink
 * @return {{ type: 'SET_PANEL_SHRINKED', kind: PreviewPanelEntityKind, id: number, shrink: boolean }}
 */
export const setPreviewPanelShrink = (kind, id, shrink) => {
  return {
    type: SET_PANEL_SHRINKED,
    shrink,
    kind,
    id,
  }
}

/**
 * @param {PreviewPanelEntityKind} kind
 * @param {number} id
 * @return {function(Dispatch, GetState): Void}
 */
export const anchorPreviewPanel = (kind, id) => (dispatch, getState) => {
  const actions = (() => {
    switch (kind) {
      case 'notes': {
        return {
          unPinAction: unpinNote,
          pinAction: pinNote,
        }
      }
      case 'cards': {
        return {
          unPinAction: unpinCard,
          pinAction: pinCard,
        }
      }
      case 'characters': {
        return {
          unPinAction: unpinCharacter,
          pinAction: pinCharacter,
        }
      }
      case 'places': {
        return {
          unPinAction: unpinPlace,
          pinAction: pinPlace,
        }
      }
      default: {
        return null
      }
    }
  })()
  const panel = allPreviewPanelsAsFlatArraySelector(getState()).find((item) => {
    return item.id === id && item.kind === kind
  })

  if (panel && actions) {
    dispatch(actions.unPinAction(id))
    setTimeout(() => {
      dispatch(actions.pinAction(id))
      if (panel.shrinked) {
        dispatch(setPreviewPanelShrink(kind, id, true))
      }
    }, 0)
  }
}

// Bookmarks

/**
 * @param {number} id
 * @return {{ type: 'ADD_CHARACTER_TO_BOOKMARKS', id: number }}
 */
export const addCharacterToBookmarks = (id) => {
  return { type: ADD_CHARACTER_TO_BOOKMARKS, id }
}

/**
 * @param {number} id
 * @return {{ type: 'REMOVE_CHARACTER_FROM_BOOKMARKS', id: number }}
 */
export function removeCharacterFromBookmarks(id) {
  return { type: REMOVE_CHARACTER_FROM_BOOKMARKS, id }
}

/**
 * @param {number} id
 * @return {{ type: 'ADD_NOTE_TO_BOOKMARKS', id: number }}
 */
export const addNoteToBookmarks = (id) => {
  return { type: ADD_NOTE_TO_BOOKMARKS, id }
}

/**
 * @param {number} id
 * @return {{ type: 'REMOVE_NOTE_FROM_BOOKMARKS', id: number }}
 */
export function removeNoteFromBookmarks(id) {
  return { type: REMOVE_NOTE_FROM_BOOKMARKS, id }
}

/**
 * @param {number} id
 * @return {{ type: 'ADD_PLACE_TO_BOOKMARKS', id: number }}
 */
export const addPlaceToBookmarks = (id) => {
  return { type: ADD_PLACE_TO_BOOKMARKS, id }
}

/**
 * @param {number} id
 * @return {{ type: 'REMOVE_PLACE_FROM_BOOKMARKS', id: number }}
 */
export function removePlaceFromBookMarks(id) {
  return { type: REMOVE_PLACE_FROM_BOOKMARKS, id }
}

/**
 * @param {number} id
 * @param {'series' | number} bookId
 * @return {{ type: ADD_CARD_TO_BOOKMARKS, id: number, bookId: 'series' | number }}
 */
export const _addCardToBookmarks = (id, bookId) => {
  return { type: ADD_CARD_TO_BOOKMARKS, id, bookId }
}

/**
 * @param {number} id
 * @return {function(Dispatch, GetState): Void}
 */
export const addCardToBookmarks = (id) => (dispatch, getState) => {
  const bookId = currentTimelineSelector(getState())
  dispatch(_addCardToBookmarks(id, bookId))
}

/**
 * @param {number} id
 * @return {{ type: 'REMOVE_CARD_FROM_BOOKMARKS', id: number }}
 */
export function removeCardFromBookmarks(id) {
  return { type: REMOVE_CARD_FROM_BOOKMARKS, id }
}

// Idea board

/**
 * @return {{ type: 'SHOW_IDEA_BOARD' }}
 */
export const showIdeaBoard = () => {
  return {
    type: SHOW_IDEA_BOARD,
  }
}

/**
 * @return {{ type: 'HIDE_IDEA_BOARD' }}
 */
export const hideIdeaBoard = () => {
  return {
    type: HIDE_IDEA_BOARD,
  }
}

/**
 * @param {number | Null} id
 * @return {{ type: 'SHOW_IDEA_BOARD_PREVIEW_MODAL', id: number | Null }}
 */
export const showIdeaBoardPreviewModal = (id) => {
  return {
    type: SHOW_IDEA_BOARD_PREVIEW_MODAL,
    id,
  }
}

/**
 * @return {{ type: 'CLOSE_IDEA_BOARD_PREVIEW_MODAL' }}
 */
export const closeIdeaBoardPreviewModal = () => {
  return {
    type: CLOSE_IDEA_BOARD_PREVIEW_MODAL,
  }
}

/**
 * @param {String} title
 * @param {TextAttributeData} content
 * @return {{ type: 'SAVE_NEW_IDEA', title: String, description: TextAttributeData }}
 */
export const saveNewIdea = (title, content) => {
  return {
    type: SAVE_NEW_IDEA,
    title,
    description: content,
  }
}

/**
 * @param {number} id
 * @param {{ title: String, description: TextAttributeData }} attributes
 * @return {{ type: 'EDIT_IDEA', id: number, attributes: { title: String, description: TextAttributeData } }}
 */
export const editIdea = (id, attributes) => {
  return {
    type: EDIT_IDEA,
    attributes,
    id,
  }
}

/**
 * @return {{ type: 'TOGGLE_SHOW_IDEA_SEARCH_BAR' }}
 */
export function toggleShowIdeaSearchBar() {
  return { type: TOGGLE_SHOW_IDEA_SEARCH_BAR }
}

/**
 * @param {number} id
 * @return {{ type: 'DELETE_IDEA_FROM_BOARD', id: number }}
 */
export const deleteIdea = (id) => {
  return {
    type: DELETE_IDEA_FROM_BOARD,
    id,
  }
}

/**
 * @typedef TempCardModalData
 * @property {String} title
 * @property {Slate | String} description
 * @property {number | Null} audioClipId
 * @property {UniversalIdeaId} [pocketIdeaId]
 */

/**
 * @return {{ type: 'CLOSE_IDEA_BOARD_PREVIEW_MODAL' }}
 */
export const _closeIdeaBoardPreviewModal = () => {
  return {
    type: CLOSE_IDEA_BOARD_PREVIEW_MODAL,
  }
}

/**
 * @return {{ type: 'HIDE_IDEA_BOARD' }}
 */
export const _hideIdeaBoard = () => {
  return {
    type: HIDE_IDEA_BOARD,
  }
}

/**
 * @typedef OptionalIdPocketIdeaIdAndLastEdited
 * @property {number} [id]
 * @property {number} [lastEdited]
 * @property {UniversalIdeaId} [pocketIdeaId]
 */

/**
 * @typedef {Omit<Omit<IdeaItem & TempCardModalData, 'id'>, 'lastEdited'> & OptionalIdPocketIdeaIdAndLastEdited} AllTempCardModalData
 */

/**
 * @param {AllTempCardModalData} data
 * @param {number | null} id
 * @return {{ type: 'OPEN_TEMP_CARD_MODAL', data: AllTempCardModalData, id: number | null }}
 */
export const _openTempCardModal = (data, id) => {
  return {
    type: OPEN_TEMP_CARD_MODAL,
    data,
    id,
  }
}

/**
 * @param {TempCardModalData} data
 * @return {function(function(PltrAction): void, function(): PlottrState): void}
 */
export const openTempCardModal = (data) => (dispatch, getState) => {
  const state = getState()
  const { id } = ideaBoardModalSelector(state)
  // if no `id`, then it is not an idea yet
  const idea = id ? singleIdeaSelector(state, id) : null
  const newData = {
    ...(idea ? idea : {}),
    ...data,
  }

  dispatch(_closeIdeaBoardPreviewModal())
  dispatch(_hideIdeaBoard())
  dispatch(_openTempCardModal(newData, id))
}

/**
 * @param {number} id
 * @param {EntityKind} section
 * @param {boolean} isDeleting
 * @param {{ title: String, description: TextAttributeData }} data
 * @return {{ type: OPEN_IDEA_CONFIRM_MODAL, id: number, section: EntityKind, isDeleting: boolean, data: { title: String, description: TextAttributeData } }}
 */
export const _openIdeaConfirmModal = (id, section, isDeleting, data) => {
  return {
    type: OPEN_IDEA_CONFIRM_MODAL,
    id,
    section,
    isDeleting,
    data,
  }
}

/**
 * @param {EntityKind} kind
 * @param {{ title: String, description: TextAttributeData }} data
 * @return {function(Dispatch, GetState): Void}
 */
export const openConfirmMoveIdeaModal = (kind, data) => (dispatch, getState) => {
  const state = getState()
  const { id } = ideaBoardModalSelector(state)

  if (id !== null) {
    dispatch(_openIdeaConfirmModal(id, kind, false, data))
  }
}

/**
 * @param {IdeaBoardEntityKind | Null} section
 * @param {number} id
 * @return {{ type: 'OPEN_IDEA_CONFIRM_MODAL', section: IdeaBoardEntityKind | Null, id: number, isDeleting: boolean }}
 */
export const openConfirmDeleteIdeaModal = (section, id) => {
  return {
    type: OPEN_IDEA_CONFIRM_MODAL,
    section,
    id,
    isDeleting: true,
  }
}

/**
 * @typedef IdeaModalData
 * @property {string} title
 * @property {String | Slate} description
 */

/**
 * @param {String} name
 * @param {String | Slate} description
 * @param {String | null} picture
 * @param {number | null} audioClip
 * @param {Array<LegacyCustomAttribute>} customAttributes
 * @param {UniversalIdeaId} [pocketIdeaId]
 * @return {{ type: 'ADD_CHARACTER_FROM_IDEA_BOARD', name: String, description: String | Slate, picture: String | null, audioClip: number | Null, customAttributes: Array<LegacyCustomAttribute>, pocketIdeaId: UniversalIdeaId | undefined }}
 */
export const _addCharacterFromIdeaBoard = (
  name,
  description,
  picture,
  audioClip,
  customAttributes,
  pocketIdeaId
) => {
  return {
    type: ADD_CHARACTER_FROM_IDEA_BOARD,
    name,
    description,
    picture,
    audioClip,
    customAttributes,
    pocketIdeaId,
  }
}

/**
 * @return {{ type: 'CLOSE_IDEA_CONFIRM_MODAL' }}
 */
export const _closeIdeaConfirmModal = () => {
  return { type: CLOSE_IDEA_CONFIRM_MODAL }
}

/**
 * @param {String} name
 * @param {String | Slate} description
 * @param {number} id
 * @param {String | null} picture
 * @param {number | null} audioClip
 * @param {Array<LegacyCustomAttribute>} customAttributes
 * @param {UniversalIdeaId} [pocketIdeaId]
 * @return {{ type: 'ADD_PLACE_FROM_IDEA_BOARD', name: String, description: String | Slate, id: number, picture: String | null, audioClip: number | Null, customAttributes: Array<LegacyCustomAttribute>, pocketIdeaId: UniversalIdeaId | undefined }}
 */
export const _addPlaceFromIdeaBoard = (
  name,
  description,
  id,
  picture,
  audioClip,
  customAttributes,
  pocketIdeaId
) => {
  return {
    type: ADD_PLACE_FROM_IDEA_BOARD,
    name,
    description,
    id,
    picture,
    audioClip,
    customAttributes,
    pocketIdeaId,
  }
}

/**
 * @param {String} title
 * @param {String | Slate} content
 * @param {number} id
 * @param {String | null} picture
 * @param {Array<LegacyCustomAttribute>} customAttributes
 * @param {number | Null} audioClip
 * @param {number} lastEdit
 * @param {UniversalIdeaId} [pocketIdeaId]
 * @return {{ type: 'ADD_NOTE_FROM_IDEA_BOARD', title: String, content: String | Slate, id: number, picture: String | null, customAttributes: Array<LegacyCustomAttribute>, audioClip: number | Null, lastEdit: number, pocketIdeaId: UniversalIdeaId | undefined }}
 */
export const _addNoteFromIdeaBoard = (
  title,
  content,
  id,
  picture,
  customAttributes,
  audioClip,
  lastEdit,
  pocketIdeaId
) => {
  return {
    type: ADD_NOTE_FROM_IDEA_BOARD,
    title,
    content,
    id,
    picture,
    customAttributes,
    audioClip,
    lastEdit,
    pocketIdeaId,
  }
}

/**
 * @param {'characters' | 'places' | 'notes'} section
 * @param {IdeaModalData} data
 * @return {function(Dispatch, GetState): Void}
 */
export const saveAsFromIdeaModal = (section, data) => (dispatch, getState) => {
  const state = getState()
  const { title, description } = data

  switch (section) {
    case 'characters': {
      const characters = allCharactersSelector(state)
      const newId = nextId(characters)
      dispatch(
        // We add extra attributes to the action in the root reducer.
        //
        // @ts-ignore
        _addCharacterFromIdeaBoard(title, description, null, null, [])
      )
      dispatch(_closeIdeaBoardPreviewModal())
      dispatch(_closeIdeaConfirmModal())
      dispatch(_hideIdeaBoard())
      dispatch(jumpFromChipToItem('characters', newId))
      break
    }

    case 'places': {
      const allPlaces = allPlacesSelector(state)
      const newId = nextId(allPlaces)
      dispatch(_addPlaceFromIdeaBoard(title, description, newId, null, null, []))
      dispatch(_closeIdeaBoardPreviewModal())
      dispatch(_closeIdeaConfirmModal())
      dispatch(_hideIdeaBoard())
      dispatch(jumpFromChipToItem('places', newId))
      break
    }

    case 'notes': {
      const allNotes = allNotesSelector(state)
      const newId = nextId(allNotes)
      dispatch(
        _addNoteFromIdeaBoard(title, description, newId, null, [], null, new Date().getTime())
      )
      dispatch(_closeIdeaBoardPreviewModal())
      dispatch(_closeIdeaConfirmModal())
      dispatch(_hideIdeaBoard())
      dispatch(jumpFromChipToItem('notes', newId))
      break
    }

    default:
      break
  }
}

/**
 * @return {{ type: 'CLOSE_IDEA_CONFIRM_MODAL' }}
 */
export const closeConfirmIdeaModal = () => {
  return {
    type: CLOSE_IDEA_CONFIRM_MODAL,
  }
}

/**
 * @return {{ type: 'TOGGLE_SHOW_PANELS_WITH_IDEABOARD' }}
 */
export const toggleShowPanelsWithIdeaBoard = () => {
  return {
    type: TOGGLE_SHOW_PANELS_WITH_IDEABOARD,
  }
}

/**
 * @return {function(Dispatch, GetState): Void}
 */
export const moveIdea = () => (dispatch, getState) => {
  const state = getState()
  const { section, id, data } = ideaConfirmModalSelector(state)
  if (typeof id === 'number') {
    const idea = singleIdeaSelector(state, id)
    if (idea) {
      const updatedData = {
        ...idea,
        ...data,
      }
      const { title, description } = updatedData

      switch (section) {
        case 'characters': {
          const characters = allCharactersSelector(state)
          const newId = nextId(characters)
          dispatch(
            // NOTE(ed): We add extra values to the action in the root
            // reducer.
            //
            // @ts-ignore
            _addCharacterFromIdeaBoard(title ?? t('Unnamed'), description, null, null, [])
          )
          dispatch(deleteIdea(idea.id))
          dispatch(_closeIdeaBoardPreviewModal())
          dispatch(closeConfirmIdeaModal())
          dispatch(_hideIdeaBoard())
          dispatch(jumpFromChipToItem('characters', newId))
          break
        }

        case 'places': {
          const allPlaces = allPlacesSelector(state)
          const newId = nextId(allPlaces)
          dispatch(
            _addPlaceFromIdeaBoard(title ?? t('Unnamed'), description, newId, null, null, [])
          )
          dispatch(deleteIdea(idea.id))
          dispatch(_closeIdeaBoardPreviewModal())
          dispatch(closeConfirmIdeaModal())
          dispatch(_hideIdeaBoard())
          dispatch(jumpFromChipToItem('places', newId))
          break
        }

        case 'notes': {
          const allNotes = allNotesSelector(state)
          const newId = nextId(allNotes)
          dispatch(
            _addNoteFromIdeaBoard(
              title ?? t('Unnamed'),
              description,
              newId,
              null,
              [],
              null,
              new Date().getTime()
            )
          )
          dispatch(deleteIdea(idea.id))
          dispatch(_closeIdeaBoardPreviewModal())
          dispatch(closeConfirmIdeaModal())
          dispatch(_hideIdeaBoard())
          dispatch(jumpFromChipToItem('notes', newId))
          break
        }

        default:
          break
      }
    } else {
      // TODO(ed): Handle the case that we couldn't find the idea with
      // a given id.
    }
  }
}

/**
 * @return {{ type: 'TOGGLE_SHOW_COLLAPSIBLE_IDEA_CARD_DESCRIPTION' }}
 */
export const toggleShowCollapsibleIdeaCardDescription = () => {
  return {
    type: TOGGLE_SHOW_COLLAPSIBLE_IDEA_CARD_DESCRIPTION,
  }
}

/**
 * @param {BookmarkEntityKind} kind
 * @return {{ type: 'TOGGLE_COLLAPSE_BOOKMARK_KIND', kind: BookmarkEntityKind }}
 */
export const toggleCollapseBookmarkKind = (kind) => {
  return {
    type: TOGGLE_COLLAPSE_BOOKMARK_KIND,
    kind,
  }
}

/**
 * @return {{ type: 'EXPAND_CHARACTER_CATEGORIES' }}
 */
export const expandCharacterCategories = () => {
  return {
    type: EXPAND_CHARACTER_CATEGORIES,
  }
}

/**
 * @return {{ type: 'COLLAPSE_CHARACTER_CATEGORIES' }}
 */
export const collapseCharacterCategories = () => {
  return {
    type: COLLAPSE_CHARACTER_CATEGORIES,
  }
}

/**
 * @return {{ type: 'TOGGLE_CHARACTERS_TAB_LIST_VIEW' }}
 */
export const toggleCharactersTabListView = () => {
  return {
    type: TOGGLE_CHARACTERS_TAB_LIST_VIEW,
  }
}

/**
 * @return {{ type: 'EXPAND_PLACE_CATEGORIES' }}
 */
export const expandPlaceCategories = () => {
  return {
    type: EXPAND_PLACE_CATEGORIES,
  }
}

/**
 * @return {{ type: 'COLLAPSE_PLACE_CATEGORIES' }}
 */
export const collapsePlaceCategories = () => {
  return {
    type: COLLAPSE_PLACE_CATEGORIES,
  }
}

/**
 * @return {{ type: 'TOGGLE_PLACES_TAB_LIST_VIEW' }}
 */
export const togglePlacesTabListView = () => {
  return {
    type: TOGGLE_PLACES_TAB_LIST_VIEW,
  }
}

/**
 * @return {{ type: 'EXPAND_NOTE_CATEGORIES' }}
 */
export const expandNoteCategories = () => {
  return {
    type: EXPAND_NOTE_CATEGORIES,
  }
}

/**
 * @return {{ type: 'COLLAPSE_NOTE_CATEGORIES' }}
 */
export const collapseNoteCategories = () => {
  return {
    type: COLLAPSE_NOTE_CATEGORIES,
  }
}

/**
 * @return {{ type: 'TOGGLE_NOTES_TAB_LIST_VIEW' }}
 */
export const toggleNotesTabListView = () => {
  return {
    type: TOGGLE_NOTES_TAB_LIST_VIEW,
  }
}

/**
 * @return {{ type: 'SET_THEME', theme: 'light-blue' | 'light-green' | 'light-orange' | Null }}
 */
export const setTheme = (theme) => {
  return {
    type: SET_THEME,
    theme,
  }
}

/**
 * @return {{ type: 'SHOW_MOBILE_CONTROLS_MODAL' }}
 */
export const showMobileControlsModal = () => {
  return {
    type: SHOW_MOBILE_CONTROLS_MODAL,
  }
}

/**
 * @return {{ type: 'HIDE_MOBILE_CONTROLS_MODAL' }}
 */
export const hideMobileControlsModal = () => {
  return {
    type: HIDE_MOBILE_CONTROLS_MODAL,
  }
}

/**
 * @param {boolean} patching
 * @param {PlottrFileUI} ui
 * @return {{ type: 'LOAD_UI', patching: boolean, ui: PlottrFileUI }}
 */
export function load(patching, ui) {
  return { type: LOAD_UI, patching, ui }
}
